import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class MineData_RewardItem {
  get descriptor() {
    return MineData_RewardItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAmountMin = false;
    this._amountMin = null;
    this._hasAmountMax = false;
    this._amountMax = null;
    this._hasChance = false;
    this._chance = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAmountMin) return false;
    if (this._hasAmountMax) return false;
    if (this._hasChance) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MineData_RewardItem) {
      return value;
    }
    return MineData_RewardItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new MineData_RewardItem();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.amountMin != null) {
      result._hasAmountMin = true;
      result._amountMin = JsonToInt32.fromJson(json.amountMin);
    }
    if (json.amountMax != null) {
      result._hasAmountMax = true;
      result._amountMax = JsonToInt32.fromJson(json.amountMax);
    }
    if (json.chance != null) {
      result._hasChance = true;
      result._chance = JsonToDouble.fromJson(json.chance);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAmountMin) {
      result.amountMin = JsonToInt32.toJson(this._amountMin);
    }
    if (this._hasAmountMax) {
      result.amountMax = JsonToInt32.toJson(this._amountMax);
    }
    if (this._hasChance) {
      result.chance = JsonToDouble.toJson(this._chance);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get amountMin() {
    return this._hasAmountMin ? this._amountMin : JsonToInt32.default;
  }
  get hasAmountMin() {
    return this._hasAmountMin;
  }
  setAmountMin(path, value) {
    return {type: 'SET', path: path.concat(['amountMin']), value};
  }
  deleteAmountMin(path) {
    return {type: 'DELETE', path: path.concat(['amountMin'])};
  }
  /**
   * @returns {number}
   */
  get amountMax() {
    return this._hasAmountMax ? this._amountMax : JsonToInt32.default;
  }
  get hasAmountMax() {
    return this._hasAmountMax;
  }
  setAmountMax(path, value) {
    return {type: 'SET', path: path.concat(['amountMax']), value};
  }
  deleteAmountMax(path) {
    return {type: 'DELETE', path: path.concat(['amountMax'])};
  }
  /**
   * @returns {number}
   */
  get chance() {
    return this._hasChance ? this._chance : JsonToDouble.default;
  }
  get hasChance() {
    return this._hasChance;
  }
  setChance(path, value) {
    return {type: 'SET', path: path.concat(['chance']), value};
  }
  deleteChance(path) {
    return {type: 'DELETE', path: path.concat(['chance'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardItem(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new MineData_RewardItem(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amountMin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardItem(this);
              copy._hasAmountMin = true;
              copy._amountMin = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmountMin) {
                return this;
              }
              const copy = new MineData_RewardItem(this);
              copy._hasAmountMin = false;
              copy._amountMin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amountMax": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardItem(this);
              copy._hasAmountMax = true;
              copy._amountMax = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmountMax) {
                return this;
              }
              const copy = new MineData_RewardItem(this);
              copy._hasAmountMax = false;
              copy._amountMax = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardItem(this);
              copy._hasChance = true;
              copy._chance = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChance) {
                return this;
              }
              const copy = new MineData_RewardItem(this);
              copy._hasChance = false;
              copy._chance = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MineData_RewardItem} other
   * @returns {MineData_RewardItem}
   */
  merge(other) {
    const copy = new MineData_RewardItem(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAmountMin) {
      copy._hasAmountMin = true;
      copy._amountMin = other._amountMin;
    }
    if (other._hasAmountMax) {
      copy._hasAmountMax = true;
      copy._amountMax = other._amountMax;
    }
    if (other._hasChance) {
      copy._hasChance = true;
      copy._chance = other._chance;
    }
    return copy;
  }
}
MineData_RewardItem.default = new MineData_RewardItem();
class MineData_RewardItem_Builder {
  constructor(value) {
    this._value = new MineData_RewardItem(value);
  }
  build() {
    return new MineData_RewardItem(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAmountMin(value) {
    this._value._hasAmountMin = true;
    this._value._amountMin = value;
    return this;
  }
  deleteAmountMin() {
    this._value._hasAmountMin = false;
    this._value._amountMin = null;
    return this;
  }
  setAmountMax(value) {
    this._value._hasAmountMax = true;
    this._value._amountMax = value;
    return this;
  }
  deleteAmountMax() {
    this._value._hasAmountMax = false;
    this._value._amountMax = null;
    return this;
  }
  setChance(value) {
    this._value._hasChance = true;
    this._value._chance = value;
    return this;
  }
  deleteChance() {
    this._value._hasChance = false;
    this._value._chance = null;
    return this;
  }
}
MineData_RewardItem.Builder = MineData_RewardItem_Builder;
class MineData_RewardItem_WithParent {
  /**
   * @param {MineData_RewardItem} value
   * @param {MineData_RewardItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MineData_RewardItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAmountMin() {
    if (this._cachedHasAmountMin === undefined) {
      if (this._value.hasAmountMin) {
        this._cachedHasAmountMin = true;
      } else {
        this._cachedHasAmountMin = this._parent ? this._parent.hasAmountMin : false;
      }
    }
    return this._cachedHasAmountMin;
  }
  get amountMin() {
    if (this._cachedAmountMin === undefined) {
      if (this._value.hasAmountMin) {
        this._cachedAmountMin = this._value.amountMin;
      } else {
        this._cachedAmountMin = this._parent ? this._parent.amountMin : this._value.amountMin;
      }
    }
    return this._cachedAmountMin;
  }
  get hasAmountMax() {
    if (this._cachedHasAmountMax === undefined) {
      if (this._value.hasAmountMax) {
        this._cachedHasAmountMax = true;
      } else {
        this._cachedHasAmountMax = this._parent ? this._parent.hasAmountMax : false;
      }
    }
    return this._cachedHasAmountMax;
  }
  get amountMax() {
    if (this._cachedAmountMax === undefined) {
      if (this._value.hasAmountMax) {
        this._cachedAmountMax = this._value.amountMax;
      } else {
        this._cachedAmountMax = this._parent ? this._parent.amountMax : this._value.amountMax;
      }
    }
    return this._cachedAmountMax;
  }
  get hasChance() {
    if (this._cachedHasChance === undefined) {
      if (this._value.hasChance) {
        this._cachedHasChance = true;
      } else {
        this._cachedHasChance = this._parent ? this._parent.hasChance : false;
      }
    }
    return this._cachedHasChance;
  }
  get chance() {
    if (this._cachedChance === undefined) {
      if (this._value.hasChance) {
        this._cachedChance = this._value.chance;
      } else {
        this._cachedChance = this._parent ? this._parent.chance : this._value.chance;
      }
    }
    return this._cachedChance;
  }
  update(current, parent) {
    const result = new MineData_RewardItem_WithParent(current, parent);
    return result;
  }
}
MineData_RewardItem_WithParent.default = new MineData_RewardItem_WithParent(MineData_RewardItem.default, null);
MineData_RewardItem.WithParent = MineData_RewardItem_WithParent;
class MineData_RewardItem_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get amountMin() {
    if (!this._amountMin) {
      this._amountMin = {
        name: "amountMin",
        Name: "AmountMin",
        number: 2,
        protoType: 5,
        protoName: "amount_min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amountMin;
  }
  get amountMax() {
    if (!this._amountMax) {
      this._amountMax = {
        name: "amountMax",
        Name: "AmountMax",
        number: 3,
        protoType: 5,
        protoName: "amount_max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amountMax;
  }
  get chance() {
    if (!this._chance) {
      this._chance = {
        name: "chance",
        Name: "Chance",
        number: 4,
        protoType: 1,
        protoName: "chance",
        type: JsonToDouble,
        options: {
          comments: "For slots, this is treated as weight For items, this is independent chance",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chance;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.amountMin,
        this.amountMax,
        this.chance,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmountMin",
        Name: "DummyOneofForAmountMin",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmountMax",
        Name: "DummyOneofForAmountMax",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChance",
        Name: "DummyOneofForChance",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
MineData_RewardItem.descriptor = new MineData_RewardItem_Descriptor();
class MineData_RewardSlot {
  get descriptor() {
    return MineData_RewardSlot.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._slotItems = [];
  }
  isEmpty() {
    if (this._slotItems.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MineData_RewardSlot) {
      return value;
    }
    return MineData_RewardSlot.fromJson(value);
  }
  static fromJson(json) {
    const result = new MineData_RewardSlot();
    result._slotItems = JsonToList(json.slotItems, MineData_RewardItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._slotItems.length > 0) {
      result.slotItems = ArrayToJson(this._slotItems, MineData_RewardItem);
    }
    return result;
  }
  /**
   * @returns {MineData_RewardItem[]}
   */
  get slotItems() {
    return this._slotItems;
  }
  addSlotItems(path, value) {
    return {type: 'ADD', path: path.concat(['slotItems']), value: value.toJson()};
  }
  setSlotItems(path, value) {
    return {type: 'SET', path: path.concat(['slotItems']), value: ArrayToJson(value, MineData_RewardItem)};
  }
  setSlotItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slotItems', key]), value: value.toJson()};
  }
  deleteSlotItems(path) {
    return {type: 'DELETE', path: path.concat(['slotItems'])};
  }
  deleteSlotItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slotItems', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "slotItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardSlot(this);
              copy._slotItems = [];        for (let i of value) {
                copy._slotItems.push(MineData_RewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData_RewardSlot(this);
              copy._slotItems = copy._slotItems.concat([MineData_RewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slotItems.length === 0) {
                return this;
              }
              const copy = new MineData_RewardSlot(this);
              copy._slotItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slotItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardSlot(this);
              copy._slotItems = copy._slotItems.slice();
              copy._slotItems[path[1]] = MineData_RewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData_RewardSlot(this);
              copy._slotItems = copy._slotItems.slice(0, path[1]).concat(copy._slotItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slotItems.length) {
            return this;
          }
          const oldValue = this._slotItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData_RewardSlot(this);
          copy._slotItems = copy._slotItems.slice();
          copy._slotItems[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MineData_RewardSlot} other
   * @returns {MineData_RewardSlot}
   */
  merge(other) {
    const copy = new MineData_RewardSlot(this);
    copy._slotItems = this._slotItems.concat(other._slotItems);
    return copy;
  }
}
MineData_RewardSlot.default = new MineData_RewardSlot();
class MineData_RewardSlot_Builder {
  constructor(value) {
    this._value = new MineData_RewardSlot(value);
  }
  build() {
    return new MineData_RewardSlot(this._value);
  }
  addAllSlotItems(values) {
    this._value._slotItems = this._value._slotItems.concat(values);
    return this;
  }
  addSlotItems(value) {
    this._value._slotItems = this._value._slotItems.concat([value]);
    return this;
  }
  setSlotItems(index, value) {
    this._value._slotItems = this._value._slotItems.concat();
    this._value._slotItems[index] = value;
    return this;
  }
  clearSlotItems() {
    this._value._slotItems = [];
    return this;
  }
}
MineData_RewardSlot.Builder = MineData_RewardSlot_Builder;
class MineData_RewardSlot_WithParent {
  /**
   * @param {MineData_RewardSlot} value
   * @param {MineData_RewardSlot_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MineData_RewardSlot.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfSlotItems() {
    if (!this._selfSlotItems) {
      this._selfSlotItems = [];
      for (let i of this._value.slotItems) {
        this._selfSlotItems.push(new MineData_RewardItem.WithParent(i, null));
      }
    }
    return this._selfSlotItems;
  }
  get inherentSlotItems() {
    if (!this._inherentSlotItems) {
      this._inherentSlotItems = this._parent ? this._parent.slotItems : [];
    }
    return this._inherentSlotItems;
  }
  get slotItems() {
    if (!this._allSlotItems) {
      this._allSlotItems = this._parent ? this._parent.slotItems.concat(this.selfSlotItems) : this.selfSlotItems;
    }
    return this._allSlotItems;
  }
  update(current, parent) {
    const result = new MineData_RewardSlot_WithParent(current, parent);
    if (this._selfSlotItems) {
      if (this._value.slotItems === current.slotItems) {
        result._selfSlotItems = this._selfSlotItems;
      } else {
        result._selfSlotItems = [];
        for (let i = 0; i < current.slotItems.length; i++) {
          const oldValue = this._value.slotItems[i];
          if (oldValue) {
            const oldCache = this._selfSlotItems[i];
            if (oldValue === current.slotItems[i]) {
              result._selfSlotItems[i] = oldCache;
            } else {
              result._selfSlotItems[i] = oldCache.update(current.slotItems[i], null);
            }
          } else {
            result._selfSlotItems[i] = new MineData_RewardItem.WithParent(current.slotItems[i], null);
          }
        }
      }
    }
    return result;
  }
}
MineData_RewardSlot_WithParent.default = new MineData_RewardSlot_WithParent(MineData_RewardSlot.default, null);
MineData_RewardSlot.WithParent = MineData_RewardSlot_WithParent;
class MineData_RewardSlot_Descriptor {
  get slotItems() {
    if (!this._slotItems) {
      this._slotItems = {
        name: "slotItems",
        Name: "SlotItems",
        number: 2,
        protoType: 11,
        protoName: "slot_items",
        type: MineData_RewardItem,
        isRepeated: true,
        options: {
          comments: "The chance field is treated as weight in this group",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slotItems;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.slotItems,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MineData_RewardSlot.descriptor = new MineData_RewardSlot_Descriptor();
class MineData_RewardPattern {
  get descriptor() {
    return MineData_RewardPattern.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPatternName = false;
    this._patternName = null;
    this._items = [];
    this._slots = [];
    this._hasTimeToOccurOnce = false;
    this._timeToOccurOnce = null;
  }
  isEmpty() {
    if (this._hasPatternName) return false;
    if (this._items.length > 0) return false;
    if (this._slots.length > 0) return false;
    if (this._hasTimeToOccurOnce) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MineData_RewardPattern) {
      return value;
    }
    return MineData_RewardPattern.fromJson(value);
  }
  static fromJson(json) {
    const result = new MineData_RewardPattern();
    if (json.patternName != null) {
      result._hasPatternName = true;
      result._patternName = JsonToString.fromJson(json.patternName);
    }
    result._items = JsonToList(json.items, MineData_RewardItem);
    result._slots = JsonToList(json.slots, MineData_RewardSlot);
    if (json.timeToOccurOnce != null) {
      result._hasTimeToOccurOnce = true;
      result._timeToOccurOnce = JsonToInt32.fromJson(json.timeToOccurOnce);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPatternName) {
      result.patternName = JsonToString.toJson(this._patternName);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, MineData_RewardItem);
    }
    if (this._slots.length > 0) {
      result.slots = ArrayToJson(this._slots, MineData_RewardSlot);
    }
    if (this._hasTimeToOccurOnce) {
      result.timeToOccurOnce = JsonToInt32.toJson(this._timeToOccurOnce);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get patternName() {
    return this._hasPatternName ? this._patternName : JsonToString.default;
  }
  get hasPatternName() {
    return this._hasPatternName;
  }
  setPatternName(path, value) {
    return {type: 'SET', path: path.concat(['patternName']), value};
  }
  deletePatternName(path) {
    return {type: 'DELETE', path: path.concat(['patternName'])};
  }
  /**
   * @returns {MineData_RewardItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, MineData_RewardItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  /**
   * @returns {MineData_RewardSlot[]}
   */
  get slots() {
    return this._slots;
  }
  addSlots(path, value) {
    return {type: 'ADD', path: path.concat(['slots']), value: value.toJson()};
  }
  setSlots(path, value) {
    return {type: 'SET', path: path.concat(['slots']), value: ArrayToJson(value, MineData_RewardSlot)};
  }
  setSlotsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['slots', key]), value: value.toJson()};
  }
  deleteSlots(path) {
    return {type: 'DELETE', path: path.concat(['slots'])};
  }
  deleteSlotsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['slots', key])};
  }
  /**
   * @returns {number}
   */
  get timeToOccurOnce() {
    return this._hasTimeToOccurOnce ? this._timeToOccurOnce : JsonToInt32.default;
  }
  get hasTimeToOccurOnce() {
    return this._hasTimeToOccurOnce;
  }
  setTimeToOccurOnce(path, value) {
    return {type: 'SET', path: path.concat(['timeToOccurOnce']), value};
  }
  deleteTimeToOccurOnce(path) {
    return {type: 'DELETE', path: path.concat(['timeToOccurOnce'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "patternName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardPattern(this);
              copy._hasPatternName = true;
              copy._patternName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPatternName) {
                return this;
              }
              const copy = new MineData_RewardPattern(this);
              copy._hasPatternName = false;
              copy._patternName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardPattern(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(MineData_RewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData_RewardPattern(this);
              copy._items = copy._items.concat([MineData_RewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new MineData_RewardPattern(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardPattern(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = MineData_RewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData_RewardPattern(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData_RewardPattern(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      case "slots": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardPattern(this);
              copy._slots = [];        for (let i of value) {
                copy._slots.push(MineData_RewardSlot.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData_RewardPattern(this);
              copy._slots = copy._slots.concat([MineData_RewardSlot.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._slots.length === 0) {
                return this;
              }
              const copy = new MineData_RewardPattern(this);
              copy._slots = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardPattern(this);
              copy._slots = copy._slots.slice();
              copy._slots[path[1]] = MineData_RewardSlot.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData_RewardPattern(this);
              copy._slots = copy._slots.slice(0, path[1]).concat(copy._slots.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._slots.length) {
            return this;
          }
          const oldValue = this._slots[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData_RewardPattern(this);
          copy._slots = copy._slots.slice();
          copy._slots[key] = newValue;
          return copy;
        }
      }
      case "timeToOccurOnce": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_RewardPattern(this);
              copy._hasTimeToOccurOnce = true;
              copy._timeToOccurOnce = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTimeToOccurOnce) {
                return this;
              }
              const copy = new MineData_RewardPattern(this);
              copy._hasTimeToOccurOnce = false;
              copy._timeToOccurOnce = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MineData_RewardPattern} other
   * @returns {MineData_RewardPattern}
   */
  merge(other) {
    const copy = new MineData_RewardPattern(this);
    if (other._hasPatternName) {
      copy._hasPatternName = true;
      copy._patternName = other._patternName;
    }
    copy._items = this._items.concat(other._items);
    copy._slots = this._slots.concat(other._slots);
    if (other._hasTimeToOccurOnce) {
      copy._hasTimeToOccurOnce = true;
      copy._timeToOccurOnce = other._timeToOccurOnce;
    }
    return copy;
  }
}
MineData_RewardPattern.default = new MineData_RewardPattern();
class MineData_RewardPattern_Builder {
  constructor(value) {
    this._value = new MineData_RewardPattern(value);
  }
  build() {
    return new MineData_RewardPattern(this._value);
  }
  setPatternName(value) {
    this._value._hasPatternName = true;
    this._value._patternName = value;
    return this;
  }
  deletePatternName() {
    this._value._hasPatternName = false;
    this._value._patternName = null;
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
  addAllSlots(values) {
    this._value._slots = this._value._slots.concat(values);
    return this;
  }
  addSlots(value) {
    this._value._slots = this._value._slots.concat([value]);
    return this;
  }
  setSlots(index, value) {
    this._value._slots = this._value._slots.concat();
    this._value._slots[index] = value;
    return this;
  }
  clearSlots() {
    this._value._slots = [];
    return this;
  }
  setTimeToOccurOnce(value) {
    this._value._hasTimeToOccurOnce = true;
    this._value._timeToOccurOnce = value;
    return this;
  }
  deleteTimeToOccurOnce() {
    this._value._hasTimeToOccurOnce = false;
    this._value._timeToOccurOnce = null;
    return this;
  }
}
MineData_RewardPattern.Builder = MineData_RewardPattern_Builder;
class MineData_RewardPattern_WithParent {
  /**
   * @param {MineData_RewardPattern} value
   * @param {MineData_RewardPattern_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MineData_RewardPattern.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPatternName() {
    if (this._cachedHasPatternName === undefined) {
      if (this._value.hasPatternName) {
        this._cachedHasPatternName = true;
      } else {
        this._cachedHasPatternName = this._parent ? this._parent.hasPatternName : false;
      }
    }
    return this._cachedHasPatternName;
  }
  get patternName() {
    if (this._cachedPatternName === undefined) {
      if (this._value.hasPatternName) {
        this._cachedPatternName = this._value.patternName;
      } else {
        this._cachedPatternName = this._parent ? this._parent.patternName : this._value.patternName;
      }
    }
    return this._cachedPatternName;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new MineData_RewardItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get selfSlots() {
    if (!this._selfSlots) {
      this._selfSlots = [];
      for (let i of this._value.slots) {
        this._selfSlots.push(new MineData_RewardSlot.WithParent(i, null));
      }
    }
    return this._selfSlots;
  }
  get inherentSlots() {
    if (!this._inherentSlots) {
      this._inherentSlots = this._parent ? this._parent.slots : [];
    }
    return this._inherentSlots;
  }
  get slots() {
    if (!this._allSlots) {
      this._allSlots = this._parent ? this._parent.slots.concat(this.selfSlots) : this.selfSlots;
    }
    return this._allSlots;
  }
  get hasTimeToOccurOnce() {
    if (this._cachedHasTimeToOccurOnce === undefined) {
      if (this._value.hasTimeToOccurOnce) {
        this._cachedHasTimeToOccurOnce = true;
      } else {
        this._cachedHasTimeToOccurOnce = this._parent ? this._parent.hasTimeToOccurOnce : false;
      }
    }
    return this._cachedHasTimeToOccurOnce;
  }
  get timeToOccurOnce() {
    if (this._cachedTimeToOccurOnce === undefined) {
      if (this._value.hasTimeToOccurOnce) {
        this._cachedTimeToOccurOnce = this._value.timeToOccurOnce;
      } else {
        this._cachedTimeToOccurOnce = this._parent ? this._parent.timeToOccurOnce : this._value.timeToOccurOnce;
      }
    }
    return this._cachedTimeToOccurOnce;
  }
  update(current, parent) {
    const result = new MineData_RewardPattern_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new MineData_RewardItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    if (this._selfSlots) {
      if (this._value.slots === current.slots) {
        result._selfSlots = this._selfSlots;
      } else {
        result._selfSlots = [];
        for (let i = 0; i < current.slots.length; i++) {
          const oldValue = this._value.slots[i];
          if (oldValue) {
            const oldCache = this._selfSlots[i];
            if (oldValue === current.slots[i]) {
              result._selfSlots[i] = oldCache;
            } else {
              result._selfSlots[i] = oldCache.update(current.slots[i], null);
            }
          } else {
            result._selfSlots[i] = new MineData_RewardSlot.WithParent(current.slots[i], null);
          }
        }
      }
    }
    return result;
  }
}
MineData_RewardPattern_WithParent.default = new MineData_RewardPattern_WithParent(MineData_RewardPattern.default, null);
MineData_RewardPattern.WithParent = MineData_RewardPattern_WithParent;
class MineData_RewardPattern_Descriptor {
  get patternName() {
    if (!this._patternName) {
      this._patternName = {
        name: "patternName",
        Name: "PatternName",
        number: 1,
        protoType: 9,
        protoName: "pattern_name",
        type: JsonToString,
        options: {
          comments: "This MUST be unique among all patterns",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._patternName;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 2,
        protoType: 11,
        protoName: "items",
        type: MineData_RewardItem,
        isRepeated: true,
        options: {
          comments: "This means the chance field will roll on its own for all items",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get slots() {
    if (!this._slots) {
      this._slots = {
        name: "slots",
        Name: "Slots",
        number: 3,
        protoType: 11,
        protoName: "slots",
        type: MineData_RewardSlot,
        isRepeated: true,
        options: {
          comments: "Each slot will guarantee to drop exactly 1 item among all items in that slot",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._slots;
  }
  get timeToOccurOnce() {
    if (!this._timeToOccurOnce) {
      this._timeToOccurOnce = {
        name: "timeToOccurOnce",
        Name: "TimeToOccurOnce",
        number: 4,
        protoType: 5,
        protoName: "time_to_occur_once",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds meanning how many seconds the reward will happen once",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._timeToOccurOnce;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.patternName,
        this.items,
        this.slots,
        this.timeToOccurOnce,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPatternName",
        Name: "DummyOneofForPatternName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTimeToOccurOnce",
        Name: "DummyOneofForTimeToOccurOnce",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
MineData_RewardPattern.descriptor = new MineData_RewardPattern_Descriptor();
class MineData_FastClaimConfig {
  get descriptor() {
    return MineData_FastClaimConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasClaimTime = false;
    this._claimTime = null;
    this._hasDefaultCap = false;
    this._defaultCap = null;
    this._prices = [];
  }
  isEmpty() {
    if (this._hasClaimTime) return false;
    if (this._hasDefaultCap) return false;
    if (this._prices.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MineData_FastClaimConfig) {
      return value;
    }
    return MineData_FastClaimConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MineData_FastClaimConfig();
    if (json.claimTime != null) {
      result._hasClaimTime = true;
      result._claimTime = JsonToInt32.fromJson(json.claimTime);
    }
    if (json.defaultCap != null) {
      result._hasDefaultCap = true;
      result._defaultCap = JsonToInt32.fromJson(json.defaultCap);
    }
    result._prices = JsonToList(json.prices, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasClaimTime) {
      result.claimTime = JsonToInt32.toJson(this._claimTime);
    }
    if (this._hasDefaultCap) {
      result.defaultCap = JsonToInt32.toJson(this._defaultCap);
    }
    if (this._prices.length > 0) {
      result.prices = ArrayToJson(this._prices, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get claimTime() {
    return this._hasClaimTime ? this._claimTime : JsonToInt32.default;
  }
  get hasClaimTime() {
    return this._hasClaimTime;
  }
  setClaimTime(path, value) {
    return {type: 'SET', path: path.concat(['claimTime']), value};
  }
  deleteClaimTime(path) {
    return {type: 'DELETE', path: path.concat(['claimTime'])};
  }
  /**
   * @returns {number}
   */
  get defaultCap() {
    return this._hasDefaultCap ? this._defaultCap : JsonToInt32.default;
  }
  get hasDefaultCap() {
    return this._hasDefaultCap;
  }
  setDefaultCap(path, value) {
    return {type: 'SET', path: path.concat(['defaultCap']), value};
  }
  deleteDefaultCap(path) {
    return {type: 'DELETE', path: path.concat(['defaultCap'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get prices() {
    return this._prices;
  }
  addPrices(path, value) {
    return {type: 'ADD', path: path.concat(['prices']), value: value.toJson()};
  }
  setPrices(path, value) {
    return {type: 'SET', path: path.concat(['prices']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setPricesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['prices', key]), value: value.toJson()};
  }
  deletePrices(path) {
    return {type: 'DELETE', path: path.concat(['prices'])};
  }
  deletePricesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['prices', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "claimTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_FastClaimConfig(this);
              copy._hasClaimTime = true;
              copy._claimTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClaimTime) {
                return this;
              }
              const copy = new MineData_FastClaimConfig(this);
              copy._hasClaimTime = false;
              copy._claimTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "defaultCap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_FastClaimConfig(this);
              copy._hasDefaultCap = true;
              copy._defaultCap = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDefaultCap) {
                return this;
              }
              const copy = new MineData_FastClaimConfig(this);
              copy._hasDefaultCap = false;
              copy._defaultCap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "prices": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_FastClaimConfig(this);
              copy._prices = [];        for (let i of value) {
                copy._prices.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData_FastClaimConfig(this);
              copy._prices = copy._prices.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._prices.length === 0) {
                return this;
              }
              const copy = new MineData_FastClaimConfig(this);
              copy._prices = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._prices.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData_FastClaimConfig(this);
              copy._prices = copy._prices.slice();
              copy._prices[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData_FastClaimConfig(this);
              copy._prices = copy._prices.slice(0, path[1]).concat(copy._prices.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._prices.length) {
            return this;
          }
          const oldValue = this._prices[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData_FastClaimConfig(this);
          copy._prices = copy._prices.slice();
          copy._prices[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MineData_FastClaimConfig} other
   * @returns {MineData_FastClaimConfig}
   */
  merge(other) {
    const copy = new MineData_FastClaimConfig(this);
    if (other._hasClaimTime) {
      copy._hasClaimTime = true;
      copy._claimTime = other._claimTime;
    }
    if (other._hasDefaultCap) {
      copy._hasDefaultCap = true;
      copy._defaultCap = other._defaultCap;
    }
    copy._prices = this._prices.concat(other._prices);
    return copy;
  }
}
MineData_FastClaimConfig.default = new MineData_FastClaimConfig();
class MineData_FastClaimConfig_Builder {
  constructor(value) {
    this._value = new MineData_FastClaimConfig(value);
  }
  build() {
    return new MineData_FastClaimConfig(this._value);
  }
  setClaimTime(value) {
    this._value._hasClaimTime = true;
    this._value._claimTime = value;
    return this;
  }
  deleteClaimTime() {
    this._value._hasClaimTime = false;
    this._value._claimTime = null;
    return this;
  }
  setDefaultCap(value) {
    this._value._hasDefaultCap = true;
    this._value._defaultCap = value;
    return this;
  }
  deleteDefaultCap() {
    this._value._hasDefaultCap = false;
    this._value._defaultCap = null;
    return this;
  }
  addAllPrices(values) {
    this._value._prices = this._value._prices.concat(values);
    return this;
  }
  addPrices(value) {
    this._value._prices = this._value._prices.concat([value]);
    return this;
  }
  setPrices(index, value) {
    this._value._prices = this._value._prices.concat();
    this._value._prices[index] = value;
    return this;
  }
  clearPrices() {
    this._value._prices = [];
    return this;
  }
}
MineData_FastClaimConfig.Builder = MineData_FastClaimConfig_Builder;
class MineData_FastClaimConfig_WithParent {
  /**
   * @param {MineData_FastClaimConfig} value
   * @param {MineData_FastClaimConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MineData_FastClaimConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasClaimTime() {
    if (this._cachedHasClaimTime === undefined) {
      if (this._value.hasClaimTime) {
        this._cachedHasClaimTime = true;
      } else {
        this._cachedHasClaimTime = this._parent ? this._parent.hasClaimTime : false;
      }
    }
    return this._cachedHasClaimTime;
  }
  get claimTime() {
    if (this._cachedClaimTime === undefined) {
      if (this._value.hasClaimTime) {
        this._cachedClaimTime = this._value.claimTime;
      } else {
        this._cachedClaimTime = this._parent ? this._parent.claimTime : this._value.claimTime;
      }
    }
    return this._cachedClaimTime;
  }
  get hasDefaultCap() {
    if (this._cachedHasDefaultCap === undefined) {
      if (this._value.hasDefaultCap) {
        this._cachedHasDefaultCap = true;
      } else {
        this._cachedHasDefaultCap = this._parent ? this._parent.hasDefaultCap : false;
      }
    }
    return this._cachedHasDefaultCap;
  }
  get defaultCap() {
    if (this._cachedDefaultCap === undefined) {
      if (this._value.hasDefaultCap) {
        this._cachedDefaultCap = this._value.defaultCap;
      } else {
        this._cachedDefaultCap = this._parent ? this._parent.defaultCap : this._value.defaultCap;
      }
    }
    return this._cachedDefaultCap;
  }
  get selfPrices() {
    if (!this._selfPrices) {
      this._selfPrices = [];
      for (let i of this._value.prices) {
        this._selfPrices.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfPrices;
  }
  get inherentPrices() {
    if (!this._inherentPrices) {
      this._inherentPrices = this._parent ? this._parent.prices : [];
    }
    return this._inherentPrices;
  }
  get prices() {
    if (!this._allPrices) {
      this._allPrices = this._parent ? this._parent.prices.concat(this.selfPrices) : this.selfPrices;
    }
    return this._allPrices;
  }
  update(current, parent) {
    const result = new MineData_FastClaimConfig_WithParent(current, parent);
    if (this._selfPrices) {
      if (this._value.prices === current.prices) {
        result._selfPrices = this._selfPrices;
      } else {
        result._selfPrices = [];
        for (let i = 0; i < current.prices.length; i++) {
          const oldValue = this._value.prices[i];
          if (oldValue) {
            const oldCache = this._selfPrices[i];
            if (oldValue === current.prices[i]) {
              result._selfPrices[i] = oldCache;
            } else {
              result._selfPrices[i] = oldCache.update(current.prices[i], null);
            }
          } else {
            result._selfPrices[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.prices[i], null);
          }
        }
      }
    }
    return result;
  }
}
MineData_FastClaimConfig_WithParent.default = new MineData_FastClaimConfig_WithParent(MineData_FastClaimConfig.default, null);
MineData_FastClaimConfig.WithParent = MineData_FastClaimConfig_WithParent;
class MineData_FastClaimConfig_Descriptor {
  get claimTime() {
    if (!this._claimTime) {
      this._claimTime = {
        name: "claimTime",
        Name: "ClaimTime",
        number: 1,
        protoType: 5,
        protoName: "claim_time",
        type: JsonToInt32,
        options: {
          comments: "How long in seconds for fast claim",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._claimTime;
  }
  get defaultCap() {
    if (!this._defaultCap) {
      this._defaultCap = {
        name: "defaultCap",
        Name: "DefaultCap",
        number: 2,
        protoType: 5,
        protoName: "default_cap",
        type: JsonToInt32,
        options: {
          comments: "Cap for all users. This can be increased individually by having active subscription",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._defaultCap;
  }
  get prices() {
    if (!this._prices) {
      this._prices = {
        name: "prices",
        Name: "Prices",
        number: 3,
        protoType: 11,
        protoName: "prices",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prices;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.claimTime,
        this.defaultCap,
        this.prices,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForClaimTime",
        Name: "DummyOneofForClaimTime",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDefaultCap",
        Name: "DummyOneofForDefaultCap",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
MineData_FastClaimConfig.descriptor = new MineData_FastClaimConfig_Descriptor();
class MineData_KeyConfig_KeyCapConfig {
  get descriptor() {
    return MineData_KeyConfig_KeyCapConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFloorFrom = false;
    this._floorFrom = null;
    this._hasFloorTo = false;
    this._floorTo = null;
    this._hasKeyCap = false;
    this._keyCap = null;
  }
  isEmpty() {
    if (this._hasFloorFrom) return false;
    if (this._hasFloorTo) return false;
    if (this._hasKeyCap) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MineData_KeyConfig_KeyCapConfig) {
      return value;
    }
    return MineData_KeyConfig_KeyCapConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MineData_KeyConfig_KeyCapConfig();
    if (json.floorFrom != null) {
      result._hasFloorFrom = true;
      result._floorFrom = JsonToInt32.fromJson(json.floorFrom);
    }
    if (json.floorTo != null) {
      result._hasFloorTo = true;
      result._floorTo = JsonToInt32.fromJson(json.floorTo);
    }
    if (json.keyCap != null) {
      result._hasKeyCap = true;
      result._keyCap = JsonToInt32.fromJson(json.keyCap);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFloorFrom) {
      result.floorFrom = JsonToInt32.toJson(this._floorFrom);
    }
    if (this._hasFloorTo) {
      result.floorTo = JsonToInt32.toJson(this._floorTo);
    }
    if (this._hasKeyCap) {
      result.keyCap = JsonToInt32.toJson(this._keyCap);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get floorFrom() {
    return this._hasFloorFrom ? this._floorFrom : JsonToInt32.default;
  }
  get hasFloorFrom() {
    return this._hasFloorFrom;
  }
  setFloorFrom(path, value) {
    return {type: 'SET', path: path.concat(['floorFrom']), value};
  }
  deleteFloorFrom(path) {
    return {type: 'DELETE', path: path.concat(['floorFrom'])};
  }
  /**
   * @returns {number}
   */
  get floorTo() {
    return this._hasFloorTo ? this._floorTo : JsonToInt32.default;
  }
  get hasFloorTo() {
    return this._hasFloorTo;
  }
  setFloorTo(path, value) {
    return {type: 'SET', path: path.concat(['floorTo']), value};
  }
  deleteFloorTo(path) {
    return {type: 'DELETE', path: path.concat(['floorTo'])};
  }
  /**
   * @returns {number}
   */
  get keyCap() {
    return this._hasKeyCap ? this._keyCap : JsonToInt32.default;
  }
  get hasKeyCap() {
    return this._hasKeyCap;
  }
  setKeyCap(path, value) {
    return {type: 'SET', path: path.concat(['keyCap']), value};
  }
  deleteKeyCap(path) {
    return {type: 'DELETE', path: path.concat(['keyCap'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "floorFrom": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig_KeyCapConfig(this);
              copy._hasFloorFrom = true;
              copy._floorFrom = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFloorFrom) {
                return this;
              }
              const copy = new MineData_KeyConfig_KeyCapConfig(this);
              copy._hasFloorFrom = false;
              copy._floorFrom = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "floorTo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig_KeyCapConfig(this);
              copy._hasFloorTo = true;
              copy._floorTo = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFloorTo) {
                return this;
              }
              const copy = new MineData_KeyConfig_KeyCapConfig(this);
              copy._hasFloorTo = false;
              copy._floorTo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keyCap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig_KeyCapConfig(this);
              copy._hasKeyCap = true;
              copy._keyCap = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeyCap) {
                return this;
              }
              const copy = new MineData_KeyConfig_KeyCapConfig(this);
              copy._hasKeyCap = false;
              copy._keyCap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MineData_KeyConfig_KeyCapConfig} other
   * @returns {MineData_KeyConfig_KeyCapConfig}
   */
  merge(other) {
    const copy = new MineData_KeyConfig_KeyCapConfig(this);
    if (other._hasFloorFrom) {
      copy._hasFloorFrom = true;
      copy._floorFrom = other._floorFrom;
    }
    if (other._hasFloorTo) {
      copy._hasFloorTo = true;
      copy._floorTo = other._floorTo;
    }
    if (other._hasKeyCap) {
      copy._hasKeyCap = true;
      copy._keyCap = other._keyCap;
    }
    return copy;
  }
}
MineData_KeyConfig_KeyCapConfig.default = new MineData_KeyConfig_KeyCapConfig();
class MineData_KeyConfig_KeyCapConfig_Builder {
  constructor(value) {
    this._value = new MineData_KeyConfig_KeyCapConfig(value);
  }
  build() {
    return new MineData_KeyConfig_KeyCapConfig(this._value);
  }
  setFloorFrom(value) {
    this._value._hasFloorFrom = true;
    this._value._floorFrom = value;
    return this;
  }
  deleteFloorFrom() {
    this._value._hasFloorFrom = false;
    this._value._floorFrom = null;
    return this;
  }
  setFloorTo(value) {
    this._value._hasFloorTo = true;
    this._value._floorTo = value;
    return this;
  }
  deleteFloorTo() {
    this._value._hasFloorTo = false;
    this._value._floorTo = null;
    return this;
  }
  setKeyCap(value) {
    this._value._hasKeyCap = true;
    this._value._keyCap = value;
    return this;
  }
  deleteKeyCap() {
    this._value._hasKeyCap = false;
    this._value._keyCap = null;
    return this;
  }
}
MineData_KeyConfig_KeyCapConfig.Builder = MineData_KeyConfig_KeyCapConfig_Builder;
class MineData_KeyConfig_KeyCapConfig_WithParent {
  /**
   * @param {MineData_KeyConfig_KeyCapConfig} value
   * @param {MineData_KeyConfig_KeyCapConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MineData_KeyConfig_KeyCapConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFloorFrom() {
    if (this._cachedHasFloorFrom === undefined) {
      if (this._value.hasFloorFrom) {
        this._cachedHasFloorFrom = true;
      } else {
        this._cachedHasFloorFrom = this._parent ? this._parent.hasFloorFrom : false;
      }
    }
    return this._cachedHasFloorFrom;
  }
  get floorFrom() {
    if (this._cachedFloorFrom === undefined) {
      if (this._value.hasFloorFrom) {
        this._cachedFloorFrom = this._value.floorFrom;
      } else {
        this._cachedFloorFrom = this._parent ? this._parent.floorFrom : this._value.floorFrom;
      }
    }
    return this._cachedFloorFrom;
  }
  get hasFloorTo() {
    if (this._cachedHasFloorTo === undefined) {
      if (this._value.hasFloorTo) {
        this._cachedHasFloorTo = true;
      } else {
        this._cachedHasFloorTo = this._parent ? this._parent.hasFloorTo : false;
      }
    }
    return this._cachedHasFloorTo;
  }
  get floorTo() {
    if (this._cachedFloorTo === undefined) {
      if (this._value.hasFloorTo) {
        this._cachedFloorTo = this._value.floorTo;
      } else {
        this._cachedFloorTo = this._parent ? this._parent.floorTo : this._value.floorTo;
      }
    }
    return this._cachedFloorTo;
  }
  get hasKeyCap() {
    if (this._cachedHasKeyCap === undefined) {
      if (this._value.hasKeyCap) {
        this._cachedHasKeyCap = true;
      } else {
        this._cachedHasKeyCap = this._parent ? this._parent.hasKeyCap : false;
      }
    }
    return this._cachedHasKeyCap;
  }
  get keyCap() {
    if (this._cachedKeyCap === undefined) {
      if (this._value.hasKeyCap) {
        this._cachedKeyCap = this._value.keyCap;
      } else {
        this._cachedKeyCap = this._parent ? this._parent.keyCap : this._value.keyCap;
      }
    }
    return this._cachedKeyCap;
  }
  update(current, parent) {
    const result = new MineData_KeyConfig_KeyCapConfig_WithParent(current, parent);
    return result;
  }
}
MineData_KeyConfig_KeyCapConfig_WithParent.default = new MineData_KeyConfig_KeyCapConfig_WithParent(MineData_KeyConfig_KeyCapConfig.default, null);
MineData_KeyConfig_KeyCapConfig.WithParent = MineData_KeyConfig_KeyCapConfig_WithParent;
class MineData_KeyConfig_KeyCapConfig_Descriptor {
  get floorFrom() {
    if (!this._floorFrom) {
      this._floorFrom = {
        name: "floorFrom",
        Name: "FloorFrom",
        number: 1,
        protoType: 5,
        protoName: "floor_from",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._floorFrom;
  }
  get floorTo() {
    if (!this._floorTo) {
      this._floorTo = {
        name: "floorTo",
        Name: "FloorTo",
        number: 2,
        protoType: 5,
        protoName: "floor_to",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._floorTo;
  }
  get keyCap() {
    if (!this._keyCap) {
      this._keyCap = {
        name: "keyCap",
        Name: "KeyCap",
        number: 3,
        protoType: 5,
        protoName: "key_cap",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keyCap;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.floorFrom,
        this.floorTo,
        this.keyCap,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFloorFrom",
        Name: "DummyOneofForFloorFrom",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFloorTo",
        Name: "DummyOneofForFloorTo",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeyCap",
        Name: "DummyOneofForKeyCap",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MineData_KeyConfig_KeyCapConfig.descriptor = new MineData_KeyConfig_KeyCapConfig_Descriptor();
class MineData_KeyConfig {
  get descriptor() {
    return MineData_KeyConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasKeyRegenerationTime = false;
    this._keyRegenerationTime = null;
    this._hasDefaultKeyCap = false;
    this._defaultKeyCap = null;
    this._keyCapConfigs = [];
    this._purchaseKeyPrices = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasKeyRegenerationTime) return false;
    if (this._hasDefaultKeyCap) return false;
    if (this._keyCapConfigs.length > 0) return false;
    if (this._purchaseKeyPrices.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MineData_KeyConfig) {
      return value;
    }
    return MineData_KeyConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new MineData_KeyConfig();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.keyRegenerationTime != null) {
      result._hasKeyRegenerationTime = true;
      result._keyRegenerationTime = JsonToInt32.fromJson(json.keyRegenerationTime);
    }
    if (json.defaultKeyCap != null) {
      result._hasDefaultKeyCap = true;
      result._defaultKeyCap = JsonToInt32.fromJson(json.defaultKeyCap);
    }
    result._keyCapConfigs = JsonToList(json.keyCapConfigs, MineData_KeyConfig_KeyCapConfig);
    result._purchaseKeyPrices = JsonToList(json.purchaseKeyPrices, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasKeyRegenerationTime) {
      result.keyRegenerationTime = JsonToInt32.toJson(this._keyRegenerationTime);
    }
    if (this._hasDefaultKeyCap) {
      result.defaultKeyCap = JsonToInt32.toJson(this._defaultKeyCap);
    }
    if (this._keyCapConfigs.length > 0) {
      result.keyCapConfigs = ArrayToJson(this._keyCapConfigs, MineData_KeyConfig_KeyCapConfig);
    }
    if (this._purchaseKeyPrices.length > 0) {
      result.purchaseKeyPrices = ArrayToJson(this._purchaseKeyPrices, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get keyRegenerationTime() {
    return this._hasKeyRegenerationTime ? this._keyRegenerationTime : JsonToInt32.default;
  }
  get hasKeyRegenerationTime() {
    return this._hasKeyRegenerationTime;
  }
  setKeyRegenerationTime(path, value) {
    return {type: 'SET', path: path.concat(['keyRegenerationTime']), value};
  }
  deleteKeyRegenerationTime(path) {
    return {type: 'DELETE', path: path.concat(['keyRegenerationTime'])};
  }
  /**
   * @returns {number}
   */
  get defaultKeyCap() {
    return this._hasDefaultKeyCap ? this._defaultKeyCap : JsonToInt32.default;
  }
  get hasDefaultKeyCap() {
    return this._hasDefaultKeyCap;
  }
  setDefaultKeyCap(path, value) {
    return {type: 'SET', path: path.concat(['defaultKeyCap']), value};
  }
  deleteDefaultKeyCap(path) {
    return {type: 'DELETE', path: path.concat(['defaultKeyCap'])};
  }
  /**
   * @returns {MineData_KeyConfig_KeyCapConfig[]}
   */
  get keyCapConfigs() {
    return this._keyCapConfigs;
  }
  addKeyCapConfigs(path, value) {
    return {type: 'ADD', path: path.concat(['keyCapConfigs']), value: value.toJson()};
  }
  setKeyCapConfigs(path, value) {
    return {type: 'SET', path: path.concat(['keyCapConfigs']), value: ArrayToJson(value, MineData_KeyConfig_KeyCapConfig)};
  }
  setKeyCapConfigsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['keyCapConfigs', key]), value: value.toJson()};
  }
  deleteKeyCapConfigs(path) {
    return {type: 'DELETE', path: path.concat(['keyCapConfigs'])};
  }
  deleteKeyCapConfigsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['keyCapConfigs', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get purchaseKeyPrices() {
    return this._purchaseKeyPrices;
  }
  addPurchaseKeyPrices(path, value) {
    return {type: 'ADD', path: path.concat(['purchaseKeyPrices']), value: value.toJson()};
  }
  setPurchaseKeyPrices(path, value) {
    return {type: 'SET', path: path.concat(['purchaseKeyPrices']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setPurchaseKeyPricesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['purchaseKeyPrices', key]), value: value.toJson()};
  }
  deletePurchaseKeyPrices(path) {
    return {type: 'DELETE', path: path.concat(['purchaseKeyPrices'])};
  }
  deletePurchaseKeyPricesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['purchaseKeyPrices', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new MineData_KeyConfig(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keyRegenerationTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig(this);
              copy._hasKeyRegenerationTime = true;
              copy._keyRegenerationTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeyRegenerationTime) {
                return this;
              }
              const copy = new MineData_KeyConfig(this);
              copy._hasKeyRegenerationTime = false;
              copy._keyRegenerationTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "defaultKeyCap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig(this);
              copy._hasDefaultKeyCap = true;
              copy._defaultKeyCap = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDefaultKeyCap) {
                return this;
              }
              const copy = new MineData_KeyConfig(this);
              copy._hasDefaultKeyCap = false;
              copy._defaultKeyCap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keyCapConfigs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig(this);
              copy._keyCapConfigs = [];        for (let i of value) {
                copy._keyCapConfigs.push(MineData_KeyConfig_KeyCapConfig.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData_KeyConfig(this);
              copy._keyCapConfigs = copy._keyCapConfigs.concat([MineData_KeyConfig_KeyCapConfig.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._keyCapConfigs.length === 0) {
                return this;
              }
              const copy = new MineData_KeyConfig(this);
              copy._keyCapConfigs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._keyCapConfigs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig(this);
              copy._keyCapConfigs = copy._keyCapConfigs.slice();
              copy._keyCapConfigs[path[1]] = MineData_KeyConfig_KeyCapConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData_KeyConfig(this);
              copy._keyCapConfigs = copy._keyCapConfigs.slice(0, path[1]).concat(copy._keyCapConfigs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._keyCapConfigs.length) {
            return this;
          }
          const oldValue = this._keyCapConfigs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData_KeyConfig(this);
          copy._keyCapConfigs = copy._keyCapConfigs.slice();
          copy._keyCapConfigs[key] = newValue;
          return copy;
        }
      }
      case "purchaseKeyPrices": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig(this);
              copy._purchaseKeyPrices = [];        for (let i of value) {
                copy._purchaseKeyPrices.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData_KeyConfig(this);
              copy._purchaseKeyPrices = copy._purchaseKeyPrices.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._purchaseKeyPrices.length === 0) {
                return this;
              }
              const copy = new MineData_KeyConfig(this);
              copy._purchaseKeyPrices = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._purchaseKeyPrices.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData_KeyConfig(this);
              copy._purchaseKeyPrices = copy._purchaseKeyPrices.slice();
              copy._purchaseKeyPrices[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData_KeyConfig(this);
              copy._purchaseKeyPrices = copy._purchaseKeyPrices.slice(0, path[1]).concat(copy._purchaseKeyPrices.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._purchaseKeyPrices.length) {
            return this;
          }
          const oldValue = this._purchaseKeyPrices[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData_KeyConfig(this);
          copy._purchaseKeyPrices = copy._purchaseKeyPrices.slice();
          copy._purchaseKeyPrices[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MineData_KeyConfig} other
   * @returns {MineData_KeyConfig}
   */
  merge(other) {
    const copy = new MineData_KeyConfig(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasKeyRegenerationTime) {
      copy._hasKeyRegenerationTime = true;
      copy._keyRegenerationTime = other._keyRegenerationTime;
    }
    if (other._hasDefaultKeyCap) {
      copy._hasDefaultKeyCap = true;
      copy._defaultKeyCap = other._defaultKeyCap;
    }
    copy._keyCapConfigs = this._keyCapConfigs.concat(other._keyCapConfigs);
    copy._purchaseKeyPrices = this._purchaseKeyPrices.concat(other._purchaseKeyPrices);
    return copy;
  }
}
MineData_KeyConfig.default = new MineData_KeyConfig();
MineData_KeyConfig.KeyCapConfig = MineData_KeyConfig_KeyCapConfig;
class MineData_KeyConfig_Builder {
  constructor(value) {
    this._value = new MineData_KeyConfig(value);
  }
  build() {
    return new MineData_KeyConfig(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setKeyRegenerationTime(value) {
    this._value._hasKeyRegenerationTime = true;
    this._value._keyRegenerationTime = value;
    return this;
  }
  deleteKeyRegenerationTime() {
    this._value._hasKeyRegenerationTime = false;
    this._value._keyRegenerationTime = null;
    return this;
  }
  setDefaultKeyCap(value) {
    this._value._hasDefaultKeyCap = true;
    this._value._defaultKeyCap = value;
    return this;
  }
  deleteDefaultKeyCap() {
    this._value._hasDefaultKeyCap = false;
    this._value._defaultKeyCap = null;
    return this;
  }
  addAllKeyCapConfigs(values) {
    this._value._keyCapConfigs = this._value._keyCapConfigs.concat(values);
    return this;
  }
  addKeyCapConfigs(value) {
    this._value._keyCapConfigs = this._value._keyCapConfigs.concat([value]);
    return this;
  }
  setKeyCapConfigs(index, value) {
    this._value._keyCapConfigs = this._value._keyCapConfigs.concat();
    this._value._keyCapConfigs[index] = value;
    return this;
  }
  clearKeyCapConfigs() {
    this._value._keyCapConfigs = [];
    return this;
  }
  addAllPurchaseKeyPrices(values) {
    this._value._purchaseKeyPrices = this._value._purchaseKeyPrices.concat(values);
    return this;
  }
  addPurchaseKeyPrices(value) {
    this._value._purchaseKeyPrices = this._value._purchaseKeyPrices.concat([value]);
    return this;
  }
  setPurchaseKeyPrices(index, value) {
    this._value._purchaseKeyPrices = this._value._purchaseKeyPrices.concat();
    this._value._purchaseKeyPrices[index] = value;
    return this;
  }
  clearPurchaseKeyPrices() {
    this._value._purchaseKeyPrices = [];
    return this;
  }
}
MineData_KeyConfig.Builder = MineData_KeyConfig_Builder;
class MineData_KeyConfig_WithParent {
  /**
   * @param {MineData_KeyConfig} value
   * @param {MineData_KeyConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MineData_KeyConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasKeyRegenerationTime() {
    if (this._cachedHasKeyRegenerationTime === undefined) {
      if (this._value.hasKeyRegenerationTime) {
        this._cachedHasKeyRegenerationTime = true;
      } else {
        this._cachedHasKeyRegenerationTime = this._parent ? this._parent.hasKeyRegenerationTime : false;
      }
    }
    return this._cachedHasKeyRegenerationTime;
  }
  get keyRegenerationTime() {
    if (this._cachedKeyRegenerationTime === undefined) {
      if (this._value.hasKeyRegenerationTime) {
        this._cachedKeyRegenerationTime = this._value.keyRegenerationTime;
      } else {
        this._cachedKeyRegenerationTime = this._parent ? this._parent.keyRegenerationTime : this._value.keyRegenerationTime;
      }
    }
    return this._cachedKeyRegenerationTime;
  }
  get hasDefaultKeyCap() {
    if (this._cachedHasDefaultKeyCap === undefined) {
      if (this._value.hasDefaultKeyCap) {
        this._cachedHasDefaultKeyCap = true;
      } else {
        this._cachedHasDefaultKeyCap = this._parent ? this._parent.hasDefaultKeyCap : false;
      }
    }
    return this._cachedHasDefaultKeyCap;
  }
  get defaultKeyCap() {
    if (this._cachedDefaultKeyCap === undefined) {
      if (this._value.hasDefaultKeyCap) {
        this._cachedDefaultKeyCap = this._value.defaultKeyCap;
      } else {
        this._cachedDefaultKeyCap = this._parent ? this._parent.defaultKeyCap : this._value.defaultKeyCap;
      }
    }
    return this._cachedDefaultKeyCap;
  }
  get selfKeyCapConfigs() {
    if (!this._selfKeyCapConfigs) {
      this._selfKeyCapConfigs = [];
      for (let i of this._value.keyCapConfigs) {
        this._selfKeyCapConfigs.push(new MineData_KeyConfig_KeyCapConfig.WithParent(i, null));
      }
    }
    return this._selfKeyCapConfigs;
  }
  get inherentKeyCapConfigs() {
    if (!this._inherentKeyCapConfigs) {
      this._inherentKeyCapConfigs = this._parent ? this._parent.keyCapConfigs : [];
    }
    return this._inherentKeyCapConfigs;
  }
  get keyCapConfigs() {
    if (!this._allKeyCapConfigs) {
      this._allKeyCapConfigs = this._parent ? this._parent.keyCapConfigs.concat(this.selfKeyCapConfigs) : this.selfKeyCapConfigs;
    }
    return this._allKeyCapConfigs;
  }
  get selfPurchaseKeyPrices() {
    if (!this._selfPurchaseKeyPrices) {
      this._selfPurchaseKeyPrices = [];
      for (let i of this._value.purchaseKeyPrices) {
        this._selfPurchaseKeyPrices.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfPurchaseKeyPrices;
  }
  get inherentPurchaseKeyPrices() {
    if (!this._inherentPurchaseKeyPrices) {
      this._inherentPurchaseKeyPrices = this._parent ? this._parent.purchaseKeyPrices : [];
    }
    return this._inherentPurchaseKeyPrices;
  }
  get purchaseKeyPrices() {
    if (!this._allPurchaseKeyPrices) {
      this._allPurchaseKeyPrices = this._parent ? this._parent.purchaseKeyPrices.concat(this.selfPurchaseKeyPrices) : this.selfPurchaseKeyPrices;
    }
    return this._allPurchaseKeyPrices;
  }
  update(current, parent) {
    const result = new MineData_KeyConfig_WithParent(current, parent);
    if (this._selfKeyCapConfigs) {
      if (this._value.keyCapConfigs === current.keyCapConfigs) {
        result._selfKeyCapConfigs = this._selfKeyCapConfigs;
      } else {
        result._selfKeyCapConfigs = [];
        for (let i = 0; i < current.keyCapConfigs.length; i++) {
          const oldValue = this._value.keyCapConfigs[i];
          if (oldValue) {
            const oldCache = this._selfKeyCapConfigs[i];
            if (oldValue === current.keyCapConfigs[i]) {
              result._selfKeyCapConfigs[i] = oldCache;
            } else {
              result._selfKeyCapConfigs[i] = oldCache.update(current.keyCapConfigs[i], null);
            }
          } else {
            result._selfKeyCapConfigs[i] = new MineData_KeyConfig_KeyCapConfig.WithParent(current.keyCapConfigs[i], null);
          }
        }
      }
    }
    if (this._selfPurchaseKeyPrices) {
      if (this._value.purchaseKeyPrices === current.purchaseKeyPrices) {
        result._selfPurchaseKeyPrices = this._selfPurchaseKeyPrices;
      } else {
        result._selfPurchaseKeyPrices = [];
        for (let i = 0; i < current.purchaseKeyPrices.length; i++) {
          const oldValue = this._value.purchaseKeyPrices[i];
          if (oldValue) {
            const oldCache = this._selfPurchaseKeyPrices[i];
            if (oldValue === current.purchaseKeyPrices[i]) {
              result._selfPurchaseKeyPrices[i] = oldCache;
            } else {
              result._selfPurchaseKeyPrices[i] = oldCache.update(current.purchaseKeyPrices[i], null);
            }
          } else {
            result._selfPurchaseKeyPrices[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.purchaseKeyPrices[i], null);
          }
        }
      }
    }
    return result;
  }
}
MineData_KeyConfig_WithParent.default = new MineData_KeyConfig_WithParent(MineData_KeyConfig.default, null);
MineData_KeyConfig.WithParent = MineData_KeyConfig_WithParent;
class MineData_KeyConfig_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
          comments: "Which inventory item is the key used here",
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get keyRegenerationTime() {
    if (!this._keyRegenerationTime) {
      this._keyRegenerationTime = {
        name: "keyRegenerationTime",
        Name: "KeyRegenerationTime",
        number: 2,
        protoType: 5,
        protoName: "key_regeneration_time",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds to regenerate another key when not full",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keyRegenerationTime;
  }
  get defaultKeyCap() {
    if (!this._defaultKeyCap) {
      this._defaultKeyCap = {
        name: "defaultKeyCap",
        Name: "DefaultKeyCap",
        number: 3,
        protoType: 5,
        protoName: "default_key_cap",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._defaultKeyCap;
  }
  get keyCapConfigs() {
    if (!this._keyCapConfigs) {
      this._keyCapConfigs = {
        name: "keyCapConfigs",
        Name: "KeyCapConfigs",
        number: 5,
        protoType: 11,
        protoName: "key_cap_configs",
        type: MineData_KeyConfig_KeyCapConfig,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keyCapConfigs;
  }
  get purchaseKeyPrices() {
    if (!this._purchaseKeyPrices) {
      this._purchaseKeyPrices = {
        name: "purchaseKeyPrices",
        Name: "PurchaseKeyPrices",
        number: 4,
        protoType: 11,
        protoName: "purchase_key_prices",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
          comments: "Inventory key and amount pairs",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseKeyPrices;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.keyRegenerationTime,
        this.defaultKeyCap,
        this.keyCapConfigs,
        this.purchaseKeyPrices,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeyRegenerationTime",
        Name: "DummyOneofForKeyRegenerationTime",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDefaultKeyCap",
        Name: "DummyOneofForDefaultKeyCap",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
MineData_KeyConfig.descriptor = new MineData_KeyConfig_Descriptor();
class MineData_Floor {
  get descriptor() {
    return MineData_Floor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKeyRequired = false;
    this._keyRequired = null;
    this._hasMapKey = false;
    this._mapKey = null;
    this._hasDisplayImage = false;
    this._displayImage = null;
    this._generatedRewards = [];
    this._rewardPatternNames = [];
    this._beatRewards = [];
    this._hasTimeReward = false;
    this._timeReward = null;
    this._hasComingSoon = false;
    this._comingSoon = null;
  }
  isEmpty() {
    if (this._hasKeyRequired) return false;
    if (this._hasMapKey) return false;
    if (this._hasDisplayImage) return false;
    if (this._generatedRewards.length > 0) return false;
    if (this._rewardPatternNames.length > 0) return false;
    if (this._beatRewards.length > 0) return false;
    if (this._hasTimeReward) return false;
    if (this._hasComingSoon) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MineData_Floor) {
      return value;
    }
    return MineData_Floor.fromJson(value);
  }
  static fromJson(json) {
    const result = new MineData_Floor();
    if (json.keyRequired != null) {
      result._hasKeyRequired = true;
      result._keyRequired = JsonToInt32.fromJson(json.keyRequired);
    }
    if (json.mapKey != null) {
      result._hasMapKey = true;
      result._mapKey = JsonToString.fromJson(json.mapKey);
    }
    if (json.displayImage != null) {
      result._hasDisplayImage = true;
      result._displayImage = JsonToString.fromJson(json.displayImage);
    }
    result._generatedRewards = JsonToList(json.generatedRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    result._rewardPatternNames = JsonToList(json.rewardPatternNames, JsonToString);
    result._beatRewards = JsonToList(json.beatRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    if (json.timeReward != null) {
      result._hasTimeReward = true;
      result._timeReward = JsonToInt32.fromJson(json.timeReward);
    }
    if (json.comingSoon != null) {
      result._hasComingSoon = true;
      result._comingSoon = JsonToBoolean.fromJson(json.comingSoon);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKeyRequired) {
      result.keyRequired = JsonToInt32.toJson(this._keyRequired);
    }
    if (this._hasMapKey) {
      result.mapKey = JsonToString.toJson(this._mapKey);
    }
    if (this._hasDisplayImage) {
      result.displayImage = JsonToString.toJson(this._displayImage);
    }
    if (this._generatedRewards.length > 0) {
      result.generatedRewards = ArrayToJson(this._generatedRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._rewardPatternNames.length > 0) {
      result.rewardPatternNames = ArrayToJson(this._rewardPatternNames, JsonToString);
    }
    if (this._beatRewards.length > 0) {
      result.beatRewards = ArrayToJson(this._beatRewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._hasTimeReward) {
      result.timeReward = JsonToInt32.toJson(this._timeReward);
    }
    if (this._hasComingSoon) {
      result.comingSoon = JsonToBoolean.toJson(this._comingSoon);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get keyRequired() {
    return this._hasKeyRequired ? this._keyRequired : JsonToInt32.default;
  }
  get hasKeyRequired() {
    return this._hasKeyRequired;
  }
  setKeyRequired(path, value) {
    return {type: 'SET', path: path.concat(['keyRequired']), value};
  }
  deleteKeyRequired(path) {
    return {type: 'DELETE', path: path.concat(['keyRequired'])};
  }
  /**
   * @returns {string}
   */
  get mapKey() {
    return this._hasMapKey ? this._mapKey : JsonToString.default;
  }
  get hasMapKey() {
    return this._hasMapKey;
  }
  setMapKey(path, value) {
    return {type: 'SET', path: path.concat(['mapKey']), value};
  }
  deleteMapKey(path) {
    return {type: 'DELETE', path: path.concat(['mapKey'])};
  }
  /**
   * @returns {string}
   */
  get displayImage() {
    return this._hasDisplayImage ? this._displayImage : JsonToString.default;
  }
  get hasDisplayImage() {
    return this._hasDisplayImage;
  }
  setDisplayImage(path, value) {
    return {type: 'SET', path: path.concat(['displayImage']), value};
  }
  deleteDisplayImage(path) {
    return {type: 'DELETE', path: path.concat(['displayImage'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get generatedRewards() {
    return this._generatedRewards;
  }
  addGeneratedRewards(path, value) {
    return {type: 'ADD', path: path.concat(['generatedRewards']), value: value.toJson()};
  }
  setGeneratedRewards(path, value) {
    return {type: 'SET', path: path.concat(['generatedRewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setGeneratedRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['generatedRewards', key]), value: value.toJson()};
  }
  deleteGeneratedRewards(path) {
    return {type: 'DELETE', path: path.concat(['generatedRewards'])};
  }
  deleteGeneratedRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['generatedRewards', key])};
  }
  /**
   * @returns {string[]}
   */
  get rewardPatternNames() {
    return this._rewardPatternNames;
  }
  addRewardPatternNames(path, value) {
    return {type: 'ADD', path: path.concat(['rewardPatternNames']), value};
  }
  setRewardPatternNames(path, value) {
    return {type: 'SET', path: path.concat(['rewardPatternNames']), value: ArrayToJson(value, JsonToString)};
  }
  setRewardPatternNamesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardPatternNames', key]), value};
  }
  deleteRewardPatternNames(path) {
    return {type: 'DELETE', path: path.concat(['rewardPatternNames'])};
  }
  deleteRewardPatternNamesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardPatternNames', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get beatRewards() {
    return this._beatRewards;
  }
  addBeatRewards(path, value) {
    return {type: 'ADD', path: path.concat(['beatRewards']), value: value.toJson()};
  }
  setBeatRewards(path, value) {
    return {type: 'SET', path: path.concat(['beatRewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setBeatRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['beatRewards', key]), value: value.toJson()};
  }
  deleteBeatRewards(path) {
    return {type: 'DELETE', path: path.concat(['beatRewards'])};
  }
  deleteBeatRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['beatRewards', key])};
  }
  /**
   * @returns {number}
   */
  get timeReward() {
    return this._hasTimeReward ? this._timeReward : JsonToInt32.default;
  }
  get hasTimeReward() {
    return this._hasTimeReward;
  }
  setTimeReward(path, value) {
    return {type: 'SET', path: path.concat(['timeReward']), value};
  }
  deleteTimeReward(path) {
    return {type: 'DELETE', path: path.concat(['timeReward'])};
  }
  /**
   * @returns {boolean}
   */
  get comingSoon() {
    return this._hasComingSoon ? this._comingSoon : JsonToBoolean.default;
  }
  get hasComingSoon() {
    return this._hasComingSoon;
  }
  setComingSoon(path, value) {
    return {type: 'SET', path: path.concat(['comingSoon']), value};
  }
  deleteComingSoon(path) {
    return {type: 'DELETE', path: path.concat(['comingSoon'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "keyRequired": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._hasKeyRequired = true;
              copy._keyRequired = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeyRequired) {
                return this;
              }
              const copy = new MineData_Floor(this);
              copy._hasKeyRequired = false;
              copy._keyRequired = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._hasMapKey = true;
              copy._mapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapKey) {
                return this;
              }
              const copy = new MineData_Floor(this);
              copy._hasMapKey = false;
              copy._mapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._hasDisplayImage = true;
              copy._displayImage = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayImage) {
                return this;
              }
              const copy = new MineData_Floor(this);
              copy._hasDisplayImage = false;
              copy._displayImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "generatedRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._generatedRewards = [];        for (let i of value) {
                copy._generatedRewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData_Floor(this);
              copy._generatedRewards = copy._generatedRewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._generatedRewards.length === 0) {
                return this;
              }
              const copy = new MineData_Floor(this);
              copy._generatedRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._generatedRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._generatedRewards = copy._generatedRewards.slice();
              copy._generatedRewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData_Floor(this);
              copy._generatedRewards = copy._generatedRewards.slice(0, path[1]).concat(copy._generatedRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._generatedRewards.length) {
            return this;
          }
          const oldValue = this._generatedRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData_Floor(this);
          copy._generatedRewards = copy._generatedRewards.slice();
          copy._generatedRewards[key] = newValue;
          return copy;
        }
      }
      case "rewardPatternNames": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._rewardPatternNames = [];        for (let i of value) {
                copy._rewardPatternNames.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData_Floor(this);
              copy._rewardPatternNames = copy._rewardPatternNames.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardPatternNames.length === 0) {
                return this;
              }
              const copy = new MineData_Floor(this);
              copy._rewardPatternNames = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatternNames.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._rewardPatternNames = copy._rewardPatternNames.slice();
              copy._rewardPatternNames[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData_Floor(this);
              copy._rewardPatternNames = copy._rewardPatternNames.slice(0, path[1]).concat(copy._rewardPatternNames.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatternNames.length) {
            return this;
          }
          const oldValue = this._rewardPatternNames[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData_Floor(this);
          copy._rewardPatternNames = copy._rewardPatternNames.slice();
          copy._rewardPatternNames[key] = newValue;
          return copy;
        }
      }
      case "beatRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._beatRewards = [];        for (let i of value) {
                copy._beatRewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData_Floor(this);
              copy._beatRewards = copy._beatRewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._beatRewards.length === 0) {
                return this;
              }
              const copy = new MineData_Floor(this);
              copy._beatRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._beatRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._beatRewards = copy._beatRewards.slice();
              copy._beatRewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData_Floor(this);
              copy._beatRewards = copy._beatRewards.slice(0, path[1]).concat(copy._beatRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._beatRewards.length) {
            return this;
          }
          const oldValue = this._beatRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData_Floor(this);
          copy._beatRewards = copy._beatRewards.slice();
          copy._beatRewards[key] = newValue;
          return copy;
        }
      }
      case "timeReward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._hasTimeReward = true;
              copy._timeReward = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTimeReward) {
                return this;
              }
              const copy = new MineData_Floor(this);
              copy._hasTimeReward = false;
              copy._timeReward = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "comingSoon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData_Floor(this);
              copy._hasComingSoon = true;
              copy._comingSoon = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComingSoon) {
                return this;
              }
              const copy = new MineData_Floor(this);
              copy._hasComingSoon = false;
              copy._comingSoon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MineData_Floor} other
   * @returns {MineData_Floor}
   */
  merge(other) {
    const copy = new MineData_Floor(this);
    if (other._hasKeyRequired) {
      copy._hasKeyRequired = true;
      copy._keyRequired = other._keyRequired;
    }
    if (other._hasMapKey) {
      copy._hasMapKey = true;
      copy._mapKey = other._mapKey;
    }
    if (other._hasDisplayImage) {
      copy._hasDisplayImage = true;
      copy._displayImage = other._displayImage;
    }
    copy._generatedRewards = this._generatedRewards.concat(other._generatedRewards);
    copy._rewardPatternNames = this._rewardPatternNames.concat(other._rewardPatternNames);
    copy._beatRewards = this._beatRewards.concat(other._beatRewards);
    if (other._hasTimeReward) {
      copy._hasTimeReward = true;
      copy._timeReward = other._timeReward;
    }
    if (other._hasComingSoon) {
      copy._hasComingSoon = true;
      copy._comingSoon = other._comingSoon;
    }
    return copy;
  }
}
MineData_Floor.default = new MineData_Floor();
class MineData_Floor_Builder {
  constructor(value) {
    this._value = new MineData_Floor(value);
  }
  build() {
    return new MineData_Floor(this._value);
  }
  setKeyRequired(value) {
    this._value._hasKeyRequired = true;
    this._value._keyRequired = value;
    return this;
  }
  deleteKeyRequired() {
    this._value._hasKeyRequired = false;
    this._value._keyRequired = null;
    return this;
  }
  setMapKey(value) {
    this._value._hasMapKey = true;
    this._value._mapKey = value;
    return this;
  }
  deleteMapKey() {
    this._value._hasMapKey = false;
    this._value._mapKey = null;
    return this;
  }
  setDisplayImage(value) {
    this._value._hasDisplayImage = true;
    this._value._displayImage = value;
    return this;
  }
  deleteDisplayImage() {
    this._value._hasDisplayImage = false;
    this._value._displayImage = null;
    return this;
  }
  addAllGeneratedRewards(values) {
    this._value._generatedRewards = this._value._generatedRewards.concat(values);
    return this;
  }
  addGeneratedRewards(value) {
    this._value._generatedRewards = this._value._generatedRewards.concat([value]);
    return this;
  }
  setGeneratedRewards(index, value) {
    this._value._generatedRewards = this._value._generatedRewards.concat();
    this._value._generatedRewards[index] = value;
    return this;
  }
  clearGeneratedRewards() {
    this._value._generatedRewards = [];
    return this;
  }
  addAllRewardPatternNames(values) {
    this._value._rewardPatternNames = this._value._rewardPatternNames.concat(values);
    return this;
  }
  addRewardPatternNames(value) {
    this._value._rewardPatternNames = this._value._rewardPatternNames.concat([value]);
    return this;
  }
  setRewardPatternNames(index, value) {
    this._value._rewardPatternNames = this._value._rewardPatternNames.concat();
    this._value._rewardPatternNames[index] = value;
    return this;
  }
  clearRewardPatternNames() {
    this._value._rewardPatternNames = [];
    return this;
  }
  addAllBeatRewards(values) {
    this._value._beatRewards = this._value._beatRewards.concat(values);
    return this;
  }
  addBeatRewards(value) {
    this._value._beatRewards = this._value._beatRewards.concat([value]);
    return this;
  }
  setBeatRewards(index, value) {
    this._value._beatRewards = this._value._beatRewards.concat();
    this._value._beatRewards[index] = value;
    return this;
  }
  clearBeatRewards() {
    this._value._beatRewards = [];
    return this;
  }
  setTimeReward(value) {
    this._value._hasTimeReward = true;
    this._value._timeReward = value;
    return this;
  }
  deleteTimeReward() {
    this._value._hasTimeReward = false;
    this._value._timeReward = null;
    return this;
  }
  setComingSoon(value) {
    this._value._hasComingSoon = true;
    this._value._comingSoon = value;
    return this;
  }
  deleteComingSoon() {
    this._value._hasComingSoon = false;
    this._value._comingSoon = null;
    return this;
  }
}
MineData_Floor.Builder = MineData_Floor_Builder;
class MineData_Floor_WithParent {
  /**
   * @param {MineData_Floor} value
   * @param {MineData_Floor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MineData_Floor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKeyRequired() {
    if (this._cachedHasKeyRequired === undefined) {
      if (this._value.hasKeyRequired) {
        this._cachedHasKeyRequired = true;
      } else {
        this._cachedHasKeyRequired = this._parent ? this._parent.hasKeyRequired : false;
      }
    }
    return this._cachedHasKeyRequired;
  }
  get keyRequired() {
    if (this._cachedKeyRequired === undefined) {
      if (this._value.hasKeyRequired) {
        this._cachedKeyRequired = this._value.keyRequired;
      } else {
        this._cachedKeyRequired = this._parent ? this._parent.keyRequired : this._value.keyRequired;
      }
    }
    return this._cachedKeyRequired;
  }
  get hasMapKey() {
    if (this._cachedHasMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedHasMapKey = true;
      } else {
        this._cachedHasMapKey = this._parent ? this._parent.hasMapKey : false;
      }
    }
    return this._cachedHasMapKey;
  }
  get mapKey() {
    if (this._cachedMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedMapKey = this._value.mapKey;
      } else {
        this._cachedMapKey = this._parent ? this._parent.mapKey : this._value.mapKey;
      }
    }
    return this._cachedMapKey;
  }
  get hasDisplayImage() {
    if (this._cachedHasDisplayImage === undefined) {
      if (this._value.hasDisplayImage) {
        this._cachedHasDisplayImage = true;
      } else {
        this._cachedHasDisplayImage = this._parent ? this._parent.hasDisplayImage : false;
      }
    }
    return this._cachedHasDisplayImage;
  }
  get displayImage() {
    if (this._cachedDisplayImage === undefined) {
      if (this._value.hasDisplayImage) {
        this._cachedDisplayImage = this._value.displayImage;
      } else {
        this._cachedDisplayImage = this._parent ? this._parent.displayImage : this._value.displayImage;
      }
    }
    return this._cachedDisplayImage;
  }
  get selfGeneratedRewards() {
    if (!this._selfGeneratedRewards) {
      this._selfGeneratedRewards = [];
      for (let i of this._value.generatedRewards) {
        this._selfGeneratedRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfGeneratedRewards;
  }
  get inherentGeneratedRewards() {
    if (!this._inherentGeneratedRewards) {
      this._inherentGeneratedRewards = this._parent ? this._parent.generatedRewards : [];
    }
    return this._inherentGeneratedRewards;
  }
  get generatedRewards() {
    if (!this._allGeneratedRewards) {
      this._allGeneratedRewards = this._parent ? this._parent.generatedRewards.concat(this.selfGeneratedRewards) : this.selfGeneratedRewards;
    }
    return this._allGeneratedRewards;
  }
  get selfRewardPatternNames() {
    return this._value.rewardPatternNames;
  }
  get inherentRewardPatternNames() {
    if (!this._inherentRewardPatternNames) {
      this._inherentRewardPatternNames = this._parent ? this._parent.rewardPatternNames : [];
    }
    return this._inherentRewardPatternNames;
  }
  get rewardPatternNames() {
    if (!this._allRewardPatternNames) {
      this._allRewardPatternNames = this._parent ? this._parent.rewardPatternNames.concat(this.selfRewardPatternNames) : this.selfRewardPatternNames;
    }
    return this._allRewardPatternNames;
  }
  get selfBeatRewards() {
    if (!this._selfBeatRewards) {
      this._selfBeatRewards = [];
      for (let i of this._value.beatRewards) {
        this._selfBeatRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfBeatRewards;
  }
  get inherentBeatRewards() {
    if (!this._inherentBeatRewards) {
      this._inherentBeatRewards = this._parent ? this._parent.beatRewards : [];
    }
    return this._inherentBeatRewards;
  }
  get beatRewards() {
    if (!this._allBeatRewards) {
      this._allBeatRewards = this._parent ? this._parent.beatRewards.concat(this.selfBeatRewards) : this.selfBeatRewards;
    }
    return this._allBeatRewards;
  }
  get hasTimeReward() {
    if (this._cachedHasTimeReward === undefined) {
      if (this._value.hasTimeReward) {
        this._cachedHasTimeReward = true;
      } else {
        this._cachedHasTimeReward = this._parent ? this._parent.hasTimeReward : false;
      }
    }
    return this._cachedHasTimeReward;
  }
  get timeReward() {
    if (this._cachedTimeReward === undefined) {
      if (this._value.hasTimeReward) {
        this._cachedTimeReward = this._value.timeReward;
      } else {
        this._cachedTimeReward = this._parent ? this._parent.timeReward : this._value.timeReward;
      }
    }
    return this._cachedTimeReward;
  }
  get hasComingSoon() {
    if (this._cachedHasComingSoon === undefined) {
      if (this._value.hasComingSoon) {
        this._cachedHasComingSoon = true;
      } else {
        this._cachedHasComingSoon = this._parent ? this._parent.hasComingSoon : false;
      }
    }
    return this._cachedHasComingSoon;
  }
  get comingSoon() {
    if (this._cachedComingSoon === undefined) {
      if (this._value.hasComingSoon) {
        this._cachedComingSoon = this._value.comingSoon;
      } else {
        this._cachedComingSoon = this._parent ? this._parent.comingSoon : this._value.comingSoon;
      }
    }
    return this._cachedComingSoon;
  }
  update(current, parent) {
    const result = new MineData_Floor_WithParent(current, parent);
    if (this._selfGeneratedRewards) {
      if (this._value.generatedRewards === current.generatedRewards) {
        result._selfGeneratedRewards = this._selfGeneratedRewards;
      } else {
        result._selfGeneratedRewards = [];
        for (let i = 0; i < current.generatedRewards.length; i++) {
          const oldValue = this._value.generatedRewards[i];
          if (oldValue) {
            const oldCache = this._selfGeneratedRewards[i];
            if (oldValue === current.generatedRewards[i]) {
              result._selfGeneratedRewards[i] = oldCache;
            } else {
              result._selfGeneratedRewards[i] = oldCache.update(current.generatedRewards[i], null);
            }
          } else {
            result._selfGeneratedRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.generatedRewards[i], null);
          }
        }
      }
    }
    if (this._selfBeatRewards) {
      if (this._value.beatRewards === current.beatRewards) {
        result._selfBeatRewards = this._selfBeatRewards;
      } else {
        result._selfBeatRewards = [];
        for (let i = 0; i < current.beatRewards.length; i++) {
          const oldValue = this._value.beatRewards[i];
          if (oldValue) {
            const oldCache = this._selfBeatRewards[i];
            if (oldValue === current.beatRewards[i]) {
              result._selfBeatRewards[i] = oldCache;
            } else {
              result._selfBeatRewards[i] = oldCache.update(current.beatRewards[i], null);
            }
          } else {
            result._selfBeatRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.beatRewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
MineData_Floor_WithParent.default = new MineData_Floor_WithParent(MineData_Floor.default, null);
MineData_Floor.WithParent = MineData_Floor_WithParent;
class MineData_Floor_Descriptor {
  get keyRequired() {
    if (!this._keyRequired) {
      this._keyRequired = {
        name: "keyRequired",
        Name: "KeyRequired",
        number: 1,
        protoType: 5,
        protoName: "key_required",
        type: JsonToInt32,
        options: {
          comments: "How many key does this floor consume. Usually 1, but can be other non-negative number",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keyRequired;
  }
  get mapKey() {
    if (!this._mapKey) {
      this._mapKey = {
        name: "mapKey",
        Name: "MapKey",
        number: 2,
        protoType: 9,
        protoName: "map_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKey;
  }
  get displayImage() {
    if (!this._displayImage) {
      this._displayImage = {
        name: "displayImage",
        Name: "DisplayImage",
        number: 3,
        protoType: 9,
        protoName: "display_image",
        type: JsonToString,
        options: {
          comments: "Background image of each floor Values can be {min_dungeon_floor_gold, min_dungeon_floor_heor, min_dungeon_floor_spell, min_dungeon_floor_tower}",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayImage;
  }
  get generatedRewards() {
    if (!this._generatedRewards) {
      this._generatedRewards = {
        name: "generatedRewards",
        Name: "GeneratedRewards",
        number: 4,
        protoType: 11,
        protoName: "generated_rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
          comments: "The rewards here will be generated over time for the total period of time, will increase every second",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._generatedRewards;
  }
  get rewardPatternNames() {
    if (!this._rewardPatternNames) {
      this._rewardPatternNames = {
        name: "rewardPatternNames",
        Name: "RewardPatternNames",
        number: 5,
        protoType: 9,
        protoName: "reward_pattern_names",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "value in reward field means total rewards will be received for the entire period",
          valueDropdown: "MineRewardPatternNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardPatternNames;
  }
  get beatRewards() {
    if (!this._beatRewards) {
      this._beatRewards = {
        name: "beatRewards",
        Name: "BeatRewards",
        number: 6,
        protoType: 11,
        protoName: "beat_rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
          comments: "The rewards will be given every time when a player beat one floor",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._beatRewards;
  }
  get timeReward() {
    if (!this._timeReward) {
      this._timeReward = {
        name: "timeReward",
        Name: "TimeReward",
        number: 7,
        protoType: 5,
        protoName: "time_reward",
        type: JsonToInt32,
        options: {
          comments: "This reward will add x seconds to the current reward timer",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._timeReward;
  }
  get comingSoon() {
    if (!this._comingSoon) {
      this._comingSoon = {
        name: "comingSoon",
        Name: "ComingSoon",
        number: 11,
        protoType: 8,
        protoName: "coming_soon",
        type: JsonToBoolean,
        options: {
          comments: "If this flag is set, this floor is unplayable and can only be used to tell player it\'s comming soon",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comingSoon;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.keyRequired,
        this.mapKey,
        this.displayImage,
        this.generatedRewards,
        this.rewardPatternNames,
        this.beatRewards,
        this.timeReward,
        this.comingSoon,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKeyRequired",
        Name: "DummyOneofForKeyRequired",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMapKey",
        Name: "DummyOneofForMapKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayImage",
        Name: "DummyOneofForDisplayImage",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTimeReward",
        Name: "DummyOneofForTimeReward",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComingSoon",
        Name: "DummyOneofForComingSoon",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
MineData_Floor.descriptor = new MineData_Floor_Descriptor();
export class MineData {
  get descriptor() {
    return MineData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRewardTimeCap = false;
    this._rewardTimeCap = null;
    this._hasKeyConfig = false;
    this._keyConfig = null;
    this._hasFastClaimConfig = false;
    this._fastClaimConfig = null;
    this._hasDailyResetTime = false;
    this._dailyResetTime = null;
    this._floors = [];
    this._rewardPatterns = [];
  }
  isEmpty() {
    if (this._hasRewardTimeCap) return false;
    if (this._hasKeyConfig && !this._keyConfig.isEmpty()) return false;
    if (this._hasFastClaimConfig && !this._fastClaimConfig.isEmpty()) return false;
    if (this._hasDailyResetTime) return false;
    if (this._floors.length > 0) return false;
    if (this._rewardPatterns.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MineData) {
      return value;
    }
    return MineData.fromJson(value);
  }
  static fromJson(json) {
    const result = new MineData();
    if (json.rewardTimeCap != null) {
      result._hasRewardTimeCap = true;
      result._rewardTimeCap = JsonToInt32.fromJson(json.rewardTimeCap);
    }
    if (json.keyConfig != null) {
      result._hasKeyConfig = true;
      result._keyConfig = MineData_KeyConfig.fromJson(json.keyConfig);
    }
    if (json.fastClaimConfig != null) {
      result._hasFastClaimConfig = true;
      result._fastClaimConfig = MineData_FastClaimConfig.fromJson(json.fastClaimConfig);
    }
    if (json.dailyResetTime != null) {
      result._hasDailyResetTime = true;
      result._dailyResetTime = JsonToInt32.fromJson(json.dailyResetTime);
    }
    result._floors = JsonToList(json.floors, MineData_Floor);
    result._rewardPatterns = JsonToList(json.rewardPatterns, MineData_RewardPattern);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRewardTimeCap) {
      result.rewardTimeCap = JsonToInt32.toJson(this._rewardTimeCap);
    }
    if (this._hasKeyConfig && !this._keyConfig.isEmpty()) {
      result.keyConfig = MineData_KeyConfig.toJson(this._keyConfig);
    }
    if (this._hasFastClaimConfig && !this._fastClaimConfig.isEmpty()) {
      result.fastClaimConfig = MineData_FastClaimConfig.toJson(this._fastClaimConfig);
    }
    if (this._hasDailyResetTime) {
      result.dailyResetTime = JsonToInt32.toJson(this._dailyResetTime);
    }
    if (this._floors.length > 0) {
      result.floors = ArrayToJson(this._floors, MineData_Floor);
    }
    if (this._rewardPatterns.length > 0) {
      result.rewardPatterns = ArrayToJson(this._rewardPatterns, MineData_RewardPattern);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get rewardTimeCap() {
    return this._hasRewardTimeCap ? this._rewardTimeCap : JsonToInt32.default;
  }
  get hasRewardTimeCap() {
    return this._hasRewardTimeCap;
  }
  setRewardTimeCap(path, value) {
    return {type: 'SET', path: path.concat(['rewardTimeCap']), value};
  }
  deleteRewardTimeCap(path) {
    return {type: 'DELETE', path: path.concat(['rewardTimeCap'])};
  }
  /**
   * @returns {MineData_KeyConfig}
   */
  get keyConfig() {
    return this._hasKeyConfig ? this._keyConfig : MineData_KeyConfig.default;
  }
  get hasKeyConfig() {
    return this._hasKeyConfig;
  }
  setKeyConfig(path, value) {
    return {type: 'SET', path: path.concat(['keyConfig']), value: value.toJson()};
  }
  deleteKeyConfig(path) {
    return {type: 'DELETE', path: path.concat(['keyConfig'])};
  }
  /**
   * @returns {MineData_FastClaimConfig}
   */
  get fastClaimConfig() {
    return this._hasFastClaimConfig ? this._fastClaimConfig : MineData_FastClaimConfig.default;
  }
  get hasFastClaimConfig() {
    return this._hasFastClaimConfig;
  }
  setFastClaimConfig(path, value) {
    return {type: 'SET', path: path.concat(['fastClaimConfig']), value: value.toJson()};
  }
  deleteFastClaimConfig(path) {
    return {type: 'DELETE', path: path.concat(['fastClaimConfig'])};
  }
  /**
   * @returns {number}
   */
  get dailyResetTime() {
    return this._hasDailyResetTime ? this._dailyResetTime : JsonToInt32.default;
  }
  get hasDailyResetTime() {
    return this._hasDailyResetTime;
  }
  setDailyResetTime(path, value) {
    return {type: 'SET', path: path.concat(['dailyResetTime']), value};
  }
  deleteDailyResetTime(path) {
    return {type: 'DELETE', path: path.concat(['dailyResetTime'])};
  }
  /**
   * @returns {MineData_Floor[]}
   */
  get floors() {
    return this._floors;
  }
  addFloors(path, value) {
    return {type: 'ADD', path: path.concat(['floors']), value: value.toJson()};
  }
  setFloors(path, value) {
    return {type: 'SET', path: path.concat(['floors']), value: ArrayToJson(value, MineData_Floor)};
  }
  setFloorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['floors', key]), value: value.toJson()};
  }
  deleteFloors(path) {
    return {type: 'DELETE', path: path.concat(['floors'])};
  }
  deleteFloorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['floors', key])};
  }
  /**
   * @returns {MineData_RewardPattern[]}
   */
  get rewardPatterns() {
    return this._rewardPatterns;
  }
  addRewardPatterns(path, value) {
    return {type: 'ADD', path: path.concat(['rewardPatterns']), value: value.toJson()};
  }
  setRewardPatterns(path, value) {
    return {type: 'SET', path: path.concat(['rewardPatterns']), value: ArrayToJson(value, MineData_RewardPattern)};
  }
  setRewardPatternsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardPatterns', key]), value: value.toJson()};
  }
  deleteRewardPatterns(path) {
    return {type: 'DELETE', path: path.concat(['rewardPatterns'])};
  }
  deleteRewardPatternsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardPatterns', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "rewardTimeCap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData(this);
              copy._hasRewardTimeCap = true;
              copy._rewardTimeCap = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRewardTimeCap) {
                return this;
              }
              const copy = new MineData(this);
              copy._hasRewardTimeCap = false;
              copy._rewardTimeCap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "keyConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData(this);
              copy._hasKeyConfig = true;
              copy._keyConfig = MineData_KeyConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKeyConfig) {
                return this;
              }
              const copy = new MineData(this);
              copy._hasKeyConfig = false;
              copy._keyConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasKeyConfig) {
            const copy = new MineData(this);
            copy._hasKeyConfig = true;
            copy._keyConfig = MineData_KeyConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._keyConfig.apply(type, path.slice(1), value);
          if (newValue === this._keyConfig) {
            return this;
          }
          const copy = new MineData(this);
          copy._keyConfig = copy._keyConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "fastClaimConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData(this);
              copy._hasFastClaimConfig = true;
              copy._fastClaimConfig = MineData_FastClaimConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFastClaimConfig) {
                return this;
              }
              const copy = new MineData(this);
              copy._hasFastClaimConfig = false;
              copy._fastClaimConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFastClaimConfig) {
            const copy = new MineData(this);
            copy._hasFastClaimConfig = true;
            copy._fastClaimConfig = MineData_FastClaimConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._fastClaimConfig.apply(type, path.slice(1), value);
          if (newValue === this._fastClaimConfig) {
            return this;
          }
          const copy = new MineData(this);
          copy._fastClaimConfig = copy._fastClaimConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "dailyResetTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData(this);
              copy._hasDailyResetTime = true;
              copy._dailyResetTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDailyResetTime) {
                return this;
              }
              const copy = new MineData(this);
              copy._hasDailyResetTime = false;
              copy._dailyResetTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "floors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData(this);
              copy._floors = [];        for (let i of value) {
                copy._floors.push(MineData_Floor.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData(this);
              copy._floors = copy._floors.concat([MineData_Floor.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._floors.length === 0) {
                return this;
              }
              const copy = new MineData(this);
              copy._floors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._floors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData(this);
              copy._floors = copy._floors.slice();
              copy._floors[path[1]] = MineData_Floor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData(this);
              copy._floors = copy._floors.slice(0, path[1]).concat(copy._floors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._floors.length) {
            return this;
          }
          const oldValue = this._floors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData(this);
          copy._floors = copy._floors.slice();
          copy._floors[key] = newValue;
          return copy;
        }
      }
      case "rewardPatterns": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MineData(this);
              copy._rewardPatterns = [];        for (let i of value) {
                copy._rewardPatterns.push(MineData_RewardPattern.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MineData(this);
              copy._rewardPatterns = copy._rewardPatterns.concat([MineData_RewardPattern.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardPatterns.length === 0) {
                return this;
              }
              const copy = new MineData(this);
              copy._rewardPatterns = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatterns.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MineData(this);
              copy._rewardPatterns = copy._rewardPatterns.slice();
              copy._rewardPatterns[path[1]] = MineData_RewardPattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MineData(this);
              copy._rewardPatterns = copy._rewardPatterns.slice(0, path[1]).concat(copy._rewardPatterns.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatterns.length) {
            return this;
          }
          const oldValue = this._rewardPatterns[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MineData(this);
          copy._rewardPatterns = copy._rewardPatterns.slice();
          copy._rewardPatterns[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MineData} other
   * @returns {MineData}
   */
  merge(other) {
    const copy = new MineData(this);
    if (other._hasRewardTimeCap) {
      copy._hasRewardTimeCap = true;
      copy._rewardTimeCap = other._rewardTimeCap;
    }
    if (other._hasKeyConfig) {
      if (copy._hasKeyConfig) {
        copy._keyConfig = copy.keyConfig.merge(other.keyConfig);
      } else {
        copy._keyConfig = other._keyConfig;
      }
      copy._hasKeyConfig = true;
    }
    if (other._hasFastClaimConfig) {
      if (copy._hasFastClaimConfig) {
        copy._fastClaimConfig = copy.fastClaimConfig.merge(other.fastClaimConfig);
      } else {
        copy._fastClaimConfig = other._fastClaimConfig;
      }
      copy._hasFastClaimConfig = true;
    }
    if (other._hasDailyResetTime) {
      copy._hasDailyResetTime = true;
      copy._dailyResetTime = other._dailyResetTime;
    }
    copy._floors = this._floors.concat(other._floors);
    copy._rewardPatterns = this._rewardPatterns.concat(other._rewardPatterns);
    return copy;
  }
}
MineData.default = new MineData();
MineData.RewardItem = MineData_RewardItem;
MineData.RewardSlot = MineData_RewardSlot;
MineData.RewardPattern = MineData_RewardPattern;
MineData.FastClaimConfig = MineData_FastClaimConfig;
MineData.KeyConfig = MineData_KeyConfig;
MineData.Floor = MineData_Floor;
class MineData_Builder {
  constructor(value) {
    this._value = new MineData(value);
  }
  build() {
    return new MineData(this._value);
  }
  setRewardTimeCap(value) {
    this._value._hasRewardTimeCap = true;
    this._value._rewardTimeCap = value;
    return this;
  }
  deleteRewardTimeCap() {
    this._value._hasRewardTimeCap = false;
    this._value._rewardTimeCap = null;
    return this;
  }
  setKeyConfig(value) {
    this._value._hasKeyConfig = true;
    this._value._keyConfig = value;
    return this;
  }
  deleteKeyConfig() {
    this._value._hasKeyConfig = false;
    this._value._keyConfig = null;
    return this;
  }
  setFastClaimConfig(value) {
    this._value._hasFastClaimConfig = true;
    this._value._fastClaimConfig = value;
    return this;
  }
  deleteFastClaimConfig() {
    this._value._hasFastClaimConfig = false;
    this._value._fastClaimConfig = null;
    return this;
  }
  setDailyResetTime(value) {
    this._value._hasDailyResetTime = true;
    this._value._dailyResetTime = value;
    return this;
  }
  deleteDailyResetTime() {
    this._value._hasDailyResetTime = false;
    this._value._dailyResetTime = null;
    return this;
  }
  addAllFloors(values) {
    this._value._floors = this._value._floors.concat(values);
    return this;
  }
  addFloors(value) {
    this._value._floors = this._value._floors.concat([value]);
    return this;
  }
  setFloors(index, value) {
    this._value._floors = this._value._floors.concat();
    this._value._floors[index] = value;
    return this;
  }
  clearFloors() {
    this._value._floors = [];
    return this;
  }
  addAllRewardPatterns(values) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat(values);
    return this;
  }
  addRewardPatterns(value) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat([value]);
    return this;
  }
  setRewardPatterns(index, value) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat();
    this._value._rewardPatterns[index] = value;
    return this;
  }
  clearRewardPatterns() {
    this._value._rewardPatterns = [];
    return this;
  }
}
MineData.Builder = MineData_Builder;
class MineData_WithParent {
  /**
   * @param {MineData} value
   * @param {MineData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MineData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRewardTimeCap() {
    if (this._cachedHasRewardTimeCap === undefined) {
      if (this._value.hasRewardTimeCap) {
        this._cachedHasRewardTimeCap = true;
      } else {
        this._cachedHasRewardTimeCap = this._parent ? this._parent.hasRewardTimeCap : false;
      }
    }
    return this._cachedHasRewardTimeCap;
  }
  get rewardTimeCap() {
    if (this._cachedRewardTimeCap === undefined) {
      if (this._value.hasRewardTimeCap) {
        this._cachedRewardTimeCap = this._value.rewardTimeCap;
      } else {
        this._cachedRewardTimeCap = this._parent ? this._parent.rewardTimeCap : this._value.rewardTimeCap;
      }
    }
    return this._cachedRewardTimeCap;
  }
  get hasKeyConfig() {
    if (this._cachedHasKeyConfig === undefined) {
      if (this._value.hasKeyConfig) {
        this._cachedHasKeyConfig = true;
      } else {
        this._cachedHasKeyConfig = this._parent ? this._parent.hasKeyConfig : false;
      }
    }
    return this._cachedHasKeyConfig;
  }
  get keyConfig() {
    if (!this._cachedKeyConfig) {
      if (this._value.hasKeyConfig) {
        this._cachedKeyConfig = new MineData_KeyConfig.WithParent(this._value.keyConfig, this._parent && this._parent.hasKeyConfig ? this._parent.keyConfig : null);
      } else {
        this._cachedKeyConfig = this._parent ? new MineData_KeyConfig.WithParent(MineData_KeyConfig.default, this._parent.keyConfig) : MineData_KeyConfig.WithParent.default;
      }
    }
    return this._cachedKeyConfig;
  }
  get hasFastClaimConfig() {
    if (this._cachedHasFastClaimConfig === undefined) {
      if (this._value.hasFastClaimConfig) {
        this._cachedHasFastClaimConfig = true;
      } else {
        this._cachedHasFastClaimConfig = this._parent ? this._parent.hasFastClaimConfig : false;
      }
    }
    return this._cachedHasFastClaimConfig;
  }
  get fastClaimConfig() {
    if (!this._cachedFastClaimConfig) {
      if (this._value.hasFastClaimConfig) {
        this._cachedFastClaimConfig = new MineData_FastClaimConfig.WithParent(this._value.fastClaimConfig, this._parent && this._parent.hasFastClaimConfig ? this._parent.fastClaimConfig : null);
      } else {
        this._cachedFastClaimConfig = this._parent ? new MineData_FastClaimConfig.WithParent(MineData_FastClaimConfig.default, this._parent.fastClaimConfig) : MineData_FastClaimConfig.WithParent.default;
      }
    }
    return this._cachedFastClaimConfig;
  }
  get hasDailyResetTime() {
    if (this._cachedHasDailyResetTime === undefined) {
      if (this._value.hasDailyResetTime) {
        this._cachedHasDailyResetTime = true;
      } else {
        this._cachedHasDailyResetTime = this._parent ? this._parent.hasDailyResetTime : false;
      }
    }
    return this._cachedHasDailyResetTime;
  }
  get dailyResetTime() {
    if (this._cachedDailyResetTime === undefined) {
      if (this._value.hasDailyResetTime) {
        this._cachedDailyResetTime = this._value.dailyResetTime;
      } else {
        this._cachedDailyResetTime = this._parent ? this._parent.dailyResetTime : this._value.dailyResetTime;
      }
    }
    return this._cachedDailyResetTime;
  }
  get selfFloors() {
    if (!this._selfFloors) {
      this._selfFloors = [];
      for (let i of this._value.floors) {
        this._selfFloors.push(new MineData_Floor.WithParent(i, null));
      }
    }
    return this._selfFloors;
  }
  get inherentFloors() {
    if (!this._inherentFloors) {
      this._inherentFloors = this._parent ? this._parent.floors : [];
    }
    return this._inherentFloors;
  }
  get floors() {
    if (!this._allFloors) {
      this._allFloors = this._parent ? this._parent.floors.concat(this.selfFloors) : this.selfFloors;
    }
    return this._allFloors;
  }
  get selfRewardPatterns() {
    if (!this._selfRewardPatterns) {
      this._selfRewardPatterns = [];
      for (let i of this._value.rewardPatterns) {
        this._selfRewardPatterns.push(new MineData_RewardPattern.WithParent(i, null));
      }
    }
    return this._selfRewardPatterns;
  }
  get inherentRewardPatterns() {
    if (!this._inherentRewardPatterns) {
      this._inherentRewardPatterns = this._parent ? this._parent.rewardPatterns : [];
    }
    return this._inherentRewardPatterns;
  }
  get rewardPatterns() {
    if (!this._allRewardPatterns) {
      this._allRewardPatterns = this._parent ? this._parent.rewardPatterns.concat(this.selfRewardPatterns) : this.selfRewardPatterns;
    }
    return this._allRewardPatterns;
  }
  update(current, parent) {
    const result = new MineData_WithParent(current, parent);
    if (this._cachedKeyConfig && this._value.hasKeyConfig && current.hasKeyConfig) {
      if (this._value.keyConfig === current.keyConfig && this._parent === parent) {
        result._cachedKeyConfig = this._cachedKeyConfig;
      } else {
        result._cachedKeyConfig = this._cachedKeyConfig.update(current.keyConfig, parent && parent.hasKeyConfig ? parent.keyConfig : null);
      }
    }
    if (this._cachedFastClaimConfig && this._value.hasFastClaimConfig && current.hasFastClaimConfig) {
      if (this._value.fastClaimConfig === current.fastClaimConfig && this._parent === parent) {
        result._cachedFastClaimConfig = this._cachedFastClaimConfig;
      } else {
        result._cachedFastClaimConfig = this._cachedFastClaimConfig.update(current.fastClaimConfig, parent && parent.hasFastClaimConfig ? parent.fastClaimConfig : null);
      }
    }
    if (this._selfFloors) {
      if (this._value.floors === current.floors) {
        result._selfFloors = this._selfFloors;
      } else {
        result._selfFloors = [];
        for (let i = 0; i < current.floors.length; i++) {
          const oldValue = this._value.floors[i];
          if (oldValue) {
            const oldCache = this._selfFloors[i];
            if (oldValue === current.floors[i]) {
              result._selfFloors[i] = oldCache;
            } else {
              result._selfFloors[i] = oldCache.update(current.floors[i], null);
            }
          } else {
            result._selfFloors[i] = new MineData_Floor.WithParent(current.floors[i], null);
          }
        }
      }
    }
    if (this._selfRewardPatterns) {
      if (this._value.rewardPatterns === current.rewardPatterns) {
        result._selfRewardPatterns = this._selfRewardPatterns;
      } else {
        result._selfRewardPatterns = [];
        for (let i = 0; i < current.rewardPatterns.length; i++) {
          const oldValue = this._value.rewardPatterns[i];
          if (oldValue) {
            const oldCache = this._selfRewardPatterns[i];
            if (oldValue === current.rewardPatterns[i]) {
              result._selfRewardPatterns[i] = oldCache;
            } else {
              result._selfRewardPatterns[i] = oldCache.update(current.rewardPatterns[i], null);
            }
          } else {
            result._selfRewardPatterns[i] = new MineData_RewardPattern.WithParent(current.rewardPatterns[i], null);
          }
        }
      }
    }
    return result;
  }
}
MineData_WithParent.default = new MineData_WithParent(MineData.default, null);
MineData.WithParent = MineData_WithParent;
class MineData_Descriptor {
  get rewardTimeCap() {
    if (!this._rewardTimeCap) {
      this._rewardTimeCap = {
        name: "rewardTimeCap",
        Name: "RewardTimeCap",
        number: 1,
        protoType: 5,
        protoName: "reward_time_cap",
        type: JsonToInt32,
        options: {
          comments: "Time cap in seconds as the longest idle time allowed for players to claim reward. Usually 12 hours",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardTimeCap;
  }
  get keyConfig() {
    if (!this._keyConfig) {
      this._keyConfig = {
        name: "keyConfig",
        Name: "KeyConfig",
        number: 2,
        protoType: 11,
        protoName: "key_config",
        type: MineData_KeyConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keyConfig;
  }
  get fastClaimConfig() {
    if (!this._fastClaimConfig) {
      this._fastClaimConfig = {
        name: "fastClaimConfig",
        Name: "FastClaimConfig",
        number: 3,
        protoType: 11,
        protoName: "fast_claim_config",
        type: MineData_FastClaimConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fastClaimConfig;
  }
  get dailyResetTime() {
    if (!this._dailyResetTime) {
      this._dailyResetTime = {
        name: "dailyResetTime",
        Name: "DailyResetTime",
        number: 4,
        protoType: 5,
        protoName: "daily_reset_time",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds of each day that resets fast claim and key purchase",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyResetTime;
  }
  get floors() {
    if (!this._floors) {
      this._floors = {
        name: "floors",
        Name: "Floors",
        number: 11,
        protoType: 11,
        protoName: "floors",
        type: MineData_Floor,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._floors;
  }
  get rewardPatterns() {
    if (!this._rewardPatterns) {
      this._rewardPatterns = {
        name: "rewardPatterns",
        Name: "RewardPatterns",
        number: 21,
        protoType: 11,
        protoName: "reward_patterns",
        type: MineData_RewardPattern,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardPatterns;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.rewardTimeCap,
        this.keyConfig,
        this.fastClaimConfig,
        this.dailyResetTime,
        this.floors,
        this.rewardPatterns,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRewardTimeCap",
        Name: "DummyOneofForRewardTimeCap",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKeyConfig",
        Name: "DummyOneofForKeyConfig",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFastClaimConfig",
        Name: "DummyOneofForFastClaimConfig",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDailyResetTime",
        Name: "DummyOneofForDailyResetTime",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
MineData.descriptor = new MineData_Descriptor();
